import React, { Component } from "react";
import axios from "axios";
import { apiUrl, apiUrl2, apiUrl3, genevent } from "../../config/config";
import classnames from "classnames";
import $ from "jquery";
import socketIOClient from "socket.io-client";
import { MDBDataTable } from "mdbreact";
import ProgressBtn from "../../components/common/ProgressButton";
import TopNav from "../../components/common/TopNav";
import SideBar from "../../components/common/SideBar";
import LiveTag from "../../components/common/LiveTag";
import { livePatientsEnabled } from "../../config/config";
import AddModalComplete from "../verifier/AddModalComplete";
import EcgStripsModal from "./EcgStripsModal";
import "react-dropdown/style.css";
import { Toaster, toast } from "react-hot-toast";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
// import DateTimePicker from "./DateTimePicker";

import "./verifierhome.css";

import Select from "react-select";
import { ar } from "date-fns/locale";
import url from "socket.io-client/lib/url";

// Create web worker using direct path
const createWorker = () => new Worker("/static/js/worker.js");

// Live progress socket disabled — re-enable once the backend at
// https://web.mybiocalculus.com:5000 has CORS configured for cross-origin
// credentialed requests. ProgressButton handles socket === null gracefully.
// const socket = socketIOClient("https://web.mybiocalculus.com:5000");
const socket = null;

// Shared modern style for the Share Report modal's inputs — dark teal
// theme matching the rest of the dashboard (sidebar / panel headers /
// device-details page).
const modernInputStyle = {
  width: "100%",
  padding: "10px 12px",
  marginBottom: 8,
  background: "#0c2e32",            // deep-teal panel bg
  color: "#e6e6e6",
  border: "1px solid #1e6b72",      // sidebar-accent teal
  borderRadius: 8,
  fontSize: 13,
  outline: "none",
  boxSizing: "border-box",
  transition: "border-color 0.15s ease, box-shadow 0.15s ease",
};

// Section label with an icon — used to break the modal into Mail / WhatsApp
// / Schedule blocks with consistent visual rhythm.
const SectionLabel = ({ icon, text }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 6,
      color: "#8a93a0",
      fontSize: 11,
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: 0.5,
      marginBottom: 6,
    }}
  >
    <span aria-hidden="true">{icon}</span> {text}
  </div>
);

const customStyles = {
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: "10px",
    position: "relative",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: "100%",
    opacity: 0.4,
    borderRadius: 4,
  },
};
class VerifierHome extends Component {
  constructor() {
    super();
        const menus = [
          { title: "Verifier Home", url: "/verifier-home" },
          { title: "Patient list", url: "/patient-list" },
          { title: "Labled Patients", url: "/labled-patients" },
          { title: "Verified", url: "/verification-completed" },
    
        ];
        if (localStorage.getItem("verifiertype") === "8") {
          menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
        }
        if (localStorage.getItem("AdminUser") === "8") {
          menus.splice(3, 0, { title: "Device Details", url: "/device-details" });
          menus.splice(4, 0, { title: "Battery Issue", url: "/battery-issue" });
        }
    
        if (localStorage.getItem("verifiertype") === "8") {
          menus.splice(4, 0, { title: "Support Home", url: "/support-home" });
        }
        if (localStorage.getItem("verifiertype") === "8") {
          menus.splice(5, 0, { title: "QC Home", url: "/qc_home" });
        }
        if (localStorage.getItem("AdminUser") === "8") {
          menus.splice(6, 0, { title: "Report Shared", url: "/report-shared" });
        }
        if (localStorage.getItem("AdminUser") === "8") {
          menus.splice(6, 0, {
            title: "Supported Person",
            url: "/supported-persons",
          });

          }
           if (localStorage.getItem("AdminUser") === "8") {
            menus.splice(6, 0, {
              title: "Reset Password",
              url: "/ResetPassword",
            });
        }

        // Admin-only dashboards. Visible to both Admin (type 1) and
        // Admin Verifier (type 8) — matches the gate that used to live
        // inside SideBar.js before these were moved into the regular
        // dynamic menus prop. Appear as standard sidebar entries so
        // they render identically to Patient List etc.
        const _vt = localStorage.getItem("verifiertype");
        if (_vt === "8" || _vt === "1") {
          menus.push(
            { title: "Analysis Dashboard", url: "/analysis-dashboard" },
            { title: "Users by Role",      url: "/users-by-role" },
            { title: "Telemetry",          url: "/telemetry" },
            { title: "Assign Patients",    url: "/assign-patients" }
          );
        }
    
    this.state = {
      menus,
      isModalCompleteOpen: false,
      profileLink: "verifier-profile",
      patients: [],
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      tamp_min: "",
      tamp_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
      errors: {},
      userid: "",
      duration: "",
      smoking: "",
      diabetes: "",
      height: "",
      weight: "",
      hospital: "",
      phone: "",
      patient_name: "",
      email_id: "",
      dob: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      thyroid_function: "",
      cardiac_surgery: "",
      doctors: [],
      verifiers: [],
      selectedVerifierIds: [],
      selectedVerifiers: [],
      doctor_id: "",
      doctor_name: "Choose",
      selectedDoctor: null,
      data: {},
      prog_data: 0,
      loading: false,
      socketNew: socket,
      patientDetails: null,
      ipop: "",
      priority: "",
      reportstatus: "",
      percentageVerified: "",
      verifiertype: "",
      comments: "",
      newComment: "",
      customerNames: [], // all registered customers (Add Billing dropdown)
      customermailid: "",
      mailuserid: "",
      device_id: "",
      patientName: "",
      mailsubject: "",
      whatsappNumber: "",
      arrythymia: "",
      whatsappUserid: "",
      columns: [],
      stripsUserid: null, // patient _id whose uploaded ECG images the popup shows (null = closed)
      rows: [],
      searchQuery: "",
      currentPage: 1,
      // Page size matches the "Load:" dropdown at the top of the table
      // (state.batchSize). Default 50 → all 50 fetched patients render on
      // one page with no pagination strip. The dropdown's onChange keeps
      // the two values in sync.
      rowsPerPage: 50,
      pacemaker: false,
      issueReport: "",
      reportPhone: "",
      selectedType: "customer", // Add this line to set the default value
      patientmailid: "",
      patientmailsubject: "",
      patientwhatsappNumber: "",
      patientwhatsappMessage: "",
      // Patient registration number (= Patient.device_id) shown on the
      // Patient tab of the Share Report modal. Loaded from the patient
      // row when the modal opens — see the setState in the Share Report
      // open handler below.
      patientRegNumber: "",
      patientNameForShare: "",
      setCompletionDate: this.getCurrentDateTime(),
      isConfirmationModalOpen: "",
      selecetdConfirmation: "",
      selectedPatientId: null,
      selectedLabels: [],
      remarksText: "",
      user_id: "",
      currentEditUserId: null, // Add this line
      loadingEditModal: false, // Add loading state for edit modal
      batchSize: 50, // Default batch size
      totalPatients: 0,       // total matching patients on the server
      hasMorePatients: false, // more pages available beyond what's loaded
      loadingMore: false,     // "Load more" request in flight
      supportPersons: [], // list from API
      supportPerson: "", // selected support person id
      supportLevel: "",
      supportedMatter: "",
      Confirmation: "",
      prioritizeData: "No", // <-- Add this line for the new field
      clinicalCondition: "", // <-- Add this line for the new field
      // Billing gate before report sending. Admin verifiers (type 8)
      // confirm a patient has been billed via the modal; only then does
      // the "Send Report" button replace "Add Billing" for that row.
      // Uses the SAME backend route (/api/patients/confirmBilling) and
      // SAME patient field (Confirmed === "Yes") as ReportPatientsList,
      // so a patient billed from either page shows as billed on both.
      billingPatient: null,         // full patient object (for modal display)
      // Editable fields shown in the billing modal — same shape as
      // ReportPatientsList.editFields so the same backend route
      // (/updateSharedDetails) can persist edits. Saved together with
      // the /confirmBilling call so admins can review, edit, and bill
      // in one flow.
      billingFields: {
        customerName: "",
        ip_op:        "",
        doctorname:   "",
        duration:     "",
        mailReport:   "",
        whatsapp:     "",
      },
      markingBilling: false,
      // Per-customer customisation notes — stored on the customer's user
      // record (customerComments), fetched/saved via the billing modal.
      billingCustomerComments: "",
      billingCommentsSaving: false,
      customerOptions: [], // registered customers as { value: name, label, customerId } (Edit Patient dropdown)
      editCustomer: null, // customer selected in the Edit Patient modal
      editCustomerOriginal: "", // the patient's customer when the modal opened
    };
    this.selectItem = this.selectItem.bind(this);
    this.getInfo = this.getInfo.bind(this);
    this.sentMailReport = this.sentMailReport.bind(this);
    this.sentWhatsappReport = this.sentWhatsappReport.bind(this);
    this.preventDefault = this.preventDefault.bind(this);
    this.filterRows = this.filterRows.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleConfirmationClick = this.handleConfirmationClick.bind(this);
    this.handleConfirmationChange = this.handleConfirmationChange.bind(this);
    this.handleConfirmationSubmit = this.handleConfirmationSubmit.bind(this);
    this.handleConfirmationCancel = this.handleConfirmationCancel.bind(this);
  }

  componentDidMount() {
    if (
      (localStorage.getItem("verifiertype") !== "8") &
      (localStorage.getItem("verifiertype") !== "2") &
      (localStorage.getItem("verifiertype") !== "10")
    ) {
      this.props.history.push("/error");
    } else {
      this.fetchData();
      this.fetchCustomerNames();
      this.fetchCustomerOptions();
    }
  }

  // Full customer/partner list for the Add Billing dropdown.
  // The dropdown used to be built only from the customerName values found on
  // the patients currently loaded on screen, so any customer without a patient
  // in that set was missing. This pulls every registered customer (type 7).
  fetchCustomerNames = () => {
    axios
      .get(`${apiUrl}api/users/getCustomerNames`)
      .then((res) => {
        const rows = (res.data && res.data.data) || [];
        const names = rows
          .map((c) => (c.name || c.customer_details || c.customerName || "").trim())
          .filter(Boolean)
          .filter((v) => v.toUpperCase() !== "NA");
        this.setState({ customerNames: Array.from(new Set(names)).sort() });
      })
      .catch(() => this.setState({ customerNames: [] })); // fall back to patient-derived names
  };

  // Every registered customer (type 7) for the Edit Patient Customer dropdown,
  // keeping the WCN id so it can be saved with the name.
  fetchCustomerOptions = () => {
    axios
      .get(`${apiUrl}api/users/getCustomerNames`)
      .then((res) => {
        const rows = (res.data && res.data.data) || [];
        const seen = {};
        const customerOptions = rows
          .map((c) => ({
            name: String(c.name || c.customer_details || c.customerName || "").trim(),
            customerId: String(c.customerId || "").trim(),
          }))
          .filter((c) => c.name && c.name.toUpperCase() !== "NA")
          .filter((c) => (seen[c.name.toLowerCase()] ? false : (seen[c.name.toLowerCase()] = true)))
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((c) => ({
            value: c.name,
            label: c.customerId ? `${c.name} (${c.customerId})` : c.name,
            customerId: c.customerId,
          }));
        this.setState({ customerOptions });
      })
      .catch(() => this.setState({ customerOptions: [] }));
  };

  getCurrentDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 330); // Adjust UTC time by +5:30 (330 minutes)
    return now.toISOString().slice(0, 16); // Convert to "YYYY-MM-DDTHH:MM"
  };

  // Reusable date formatter — replaces inline IIFEs in the report column
  formatDateStr = (d) => {
    if (!d) return "";
    let dateObj;
    if (typeof d === "string" && d.includes("T")) {
      const cleaned = d.split(".")[0].replace("Z", "").replace(/\+\d{2}:\d{2}$/, "");
      const [datePart, timePart] = cleaned.split("T");
      if (datePart && timePart) {
        const [year, month, day] = datePart.split("-");
        const [hour, minute, second] = timePart.split(":");
        dateObj = new Date(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second));
      } else {
        dateObj = new Date(d);
      }
    } else if (typeof d === "string" && d.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
      const [datePart, timePart] = d.split(" ");
      const [year, month, day] = datePart.split("-");
      const [hour, minute, second] = timePart.split(":");
      dateObj = new Date(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second));
    } else if (typeof d === "string" && d.match(/^\d{2}\/\d{2}\/\d{4}, \d{2}:\d{2} [AP]M$/)) {
      const [datePart, timePart] = d.split(", ");
      const [month, day, year] = datePart.split("/");
      let [hourStr, rest] = timePart.split(":");
      let [min, ampm] = rest.split(" ");
      let hour = Number(hourStr);
      if (ampm === "PM" && hour !== 12) hour += 12;
      if (ampm === "AM" && hour === 12) hour = 0;
      dateObj = new Date(Number(year), Number(month) - 1, Number(day), hour, Number(min));
    } else {
      dateObj = new Date(d);
    }
    if (!dateObj || isNaN(dateObj.getTime())) return String(d);
    return (
      dateObj.toLocaleString("en-US", { month: "short", day: "2-digit", year: "numeric" }) +
      ", " +
      dateObj.toLocaleString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })
    );
  };

  fetchData = (e) => {
    const verifiertype = localStorage.getItem("verifiertype");
    this.setState({ verifiertype: verifiertype, loading: true });
  const worker = createWorker();

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    var newstat = this;
    /*socket.on('connect', function(){console.log('connected')});
    socket.on('connect_error', function(err){console.log(err)});
    socket.on('data', function(data){


      newstat.setState({"loading":true});
      
      console.log(newstat.state.loading)
    });
    socket.on('disconnect', function(){console.log('disconnected')});*/
    //   axios
    //        .get(apiUrl+'api/users/alldoctors')
    //        .then(res => {
    //          this.setState({ ['doctors']: res.data })
    //        })
    //        .catch(err => {
    //          this.setState({ ['doctors']: [] })
    //        });

    worker.postMessage({
      name: "alldoctors",
      url: apiUrl + "api/users/alldoctors",
    });
    worker.onmessage = function (event) {};
    worker.addEventListener("message", function (event) {
      newstat.setState({ ["doctors"]: event.data });
      //console.log(newstat.state.doctors);
    });
    // Get batch size from state, default to 50
    const batchSize = this.state.batchSize || 50;
    // Server-side search (finds ANY patient, not just the loaded batch) and
    // paging. `append` (from Load more) keeps existing rows and adds the next
    // skip window; otherwise we replace from skip 0.
    const search = (this.state.searchQuery || "").trim();
    const append = !!(e && e.append);
    const skip = append ? (this.state.patients || []).length : 0;

    axios
      .get(
        `${apiUrl}api/users/getVerifierPatientsPerPage?limit=${batchSize}&skip=${skip}` +
          (search ? `&search=${encodeURIComponent(search)}` : "")
      )
      .then((res) => {
        // Accept the new {patients,total,hasMore} shape and the legacy plain
        // array shape, so a not-yet-updated backend still works.
        const payload = res.data;
        const list = Array.isArray(payload) ? payload : (payload.patients || []);
        const total = Array.isArray(payload) ? list.length : (payload.total || list.length);
        const hasMore = Array.isArray(payload) ? false : !!payload.hasMore;
        // Sort priority for verifier workflow (lower number = shown first):
        // 1 → Report Completed (5)       — top priority
        // 2 → In Preparation (4)         — second
        // 3 → Verification Completed (3) — third
        // 4 → Analyze Completed (2/6)    — needs verification
        // 5 → Analyzing (1)              — in progress
        // 6 → Not Analyzed (0)           — not yet started
        const reportOrder = { 5: 1, 4: 2, 3: 3, 2: 4, 6: 4, 1: 5, 0: 6 };
        const merged = append ? [ ...(this.state.patients || []), ...list ] : list;
        const sortedData = merged.sort((a, b) => {
          const aOrder = reportOrder[a.report_status] ?? 2;
          const bOrder = reportOrder[b.report_status] ?? 2;
          if (aOrder !== bOrder) return aOrder - bOrder;
          // Secondary: backup_status 1 (archived) goes last
          const aBack = a.backup_status === 1 ? 2 : 1;
          const bBack = b.backup_status === 1 ? 2 : 1;
          if (aBack !== bBack) return aBack - bBack;
          // Tertiary: newest created_at first
          return new Date(b.created_at) - new Date(a.created_at);
        });

        // Set the sorted patients data in state
        this.setState({
          patients: sortedData,
          totalPatients: total,
          hasMorePatients: hasMore,
          loadingMore: false,
        });
        // console.log('whatsapp sent time', this.state.patients.whatsappsenttime);

        // Loop through object keys if it's not an array
        if (
          typeof this.state.patients === "object" &&
          this.state.patients !== null
        ) {
          Object.keys(this.state.patients).forEach((key) => {
            // console.log(
            //   "whatsapp sent time",
            //   this.state.patients[key].whatsappsenttime
            // );
            // console.log("mail sent time", this.state.patients[key].mailsentime);
          });
        }

        const data = {
          columns: [
            {
              label: "SL NO",
              field: "slno",
              sort: "asc",
              width: 5,
            },
            {
              label: "PATIENT ID",
              field: "patientId",
              sort: "asc",
              width: 70,
            },
            {
              label: "ADDED DATE",
              field: "added_date",
              sort: "asc",
              width: 70,
            },
            {
              label: "NAME",
              field: "name",
              sort: "asc",
              width: 130,
            },
            {
              label: "Distributor Name",
              field: "distributorName",
              sort: "disabled",
              width: 160,
            },
            {
              label: "Action",
              field: "action",
              sort: "disabled",
              width: 160,
            },
            {
              label: "REPORT",
              field: "report",
              sort: "disabled",
              width: 150,
            },
            {
              label: "REPORT",
              field: "report",
              sort: "disabled",
              width: 150,
            },
          ],
          rows: [],
        };

        var onClick = this.selectItem.bind(this);
        var getInfo = this.getInfo.bind(this);
        var getCommentInfo = this.getCommentInfo.bind(this);

        var preventDefault = this.preventDefault.bind(this);
        var createdData = "";
        const options = [
          "RPeaks",
          "Classic",
          "Classical",
          "Classic Negative",
          "AI",
          "AIcodes",
        ];
        const defaultOption = options[0];
        sortedData.map(function (patient, i) {
          // Priority is patient-level (set via the admin Priority popup,
          // PUT api/patients/updatePatientPriority) — `patient.priority` is
          // the source of truth. Fall back to legacy deviceInfo.Priority
          // only for rows that predate that change.
          const Priority =
            patient.priority !== undefined && patient.priority !== null && patient.priority !== "" && Number(patient.priority) > 0
              ? Number(patient.priority)
              : (patient.deviceInfo && patient.deviceInfo.Priority) || 4;

          // Variable to store the final time value
          let finalTime;

          // Ensure the date fields are not undefined or null before splitting
          if (patient.ConfirmupdatedDate) {
            // Split the 'ConfirmupdatedDate' by 'T' to get the date and time parts
            let confirmButtonTime = patient.ConfirmupdatedDate.split("T");

            // Get the date part before 'T'
            let confirmDate = confirmButtonTime[0]; // '2024-11-29'

            // Get the time part after 'T'
            let confirmTime = confirmButtonTime[1]
              ? confirmButtonTime[1].split("Z")[0] // Remove 'Z' if it exists
              : ""; // If no time part, default to an empty string

            // Handle removing milliseconds (if any) from confirmTime
            if (confirmTime) {
              let time = confirmTime.split(".")[0]; // Get time without milliseconds
              const confirmbtnTime = confirmDate + " " + time; // Add a space between date and time
              // console.log("Confirm button time:", confirmbtnTime);

              // Assign confirmbtnTime to finalTime if available
              finalTime = confirmbtnTime;
            } else {
              // console.log("Confirm Time is empty or invalid");
            }
          } else {
            // console.log("ConfirmupdatedDate is undefined or null");
          }

          // Check and split the 'updatedDate' if it's available
          if (patient.updatedDate) {
            // Split the 'updatedDate' by space to separate date and time
            let updatedDateTime = patient.updatedDate.split(" ");

            // Get the date part before the space
            let updatedDate = updatedDateTime[0]; // '2024-11-29'

            // Get the time part after the space
            let updatedTime = updatedDateTime[1]; // '10:28:34'

            // console.log("Updated Date:", updatedDate, updatedTime);

            // Combine updatedDate and updatedTime with a space between them
            const uploadedTime = updatedDate + " " + updatedTime;

            // Assign uploadedTime to finalTime if confirmbtnTime was not set
            if (!finalTime) {
              finalTime = uploadedTime;
            }
          } else {
            // console.log("UpdatedDate is undefined or null");
          }

          // Log the final time
          // console.log("Final Time:", finalTime);

          // Get the current time
          const now = new Date();

          // Convert finalTime to Date object
          const finalDate = new Date(finalTime);

          // Calculate the time difference in milliseconds
          const timeDifference = now - finalDate; // in milliseconds

          // Convert time difference to hours
          const hoursDifference = timeDifference / (1000 * 60 * 60); // milliseconds to hours

          // Set the time limit based on priority
          let timeLimit;
          switch (Priority) {
            case 1:
              timeLimit = 1; // 1 hours
              break;
            case 2:
              timeLimit = 2; // 3 hours
              break;
            case 3:
              timeLimit = 3;
            case 4:
              timeLimit = 4; // 4 hours
              break;
            case 5:
              timeLimit = 5; // 8 hours
              break;
            default:
              timeLimit = 4; // 10 hours (for priority 5, as an example)
          }

          // Calculate the percentage of time used

          let exp_device =
            patient.exp_device_use_days === 24
              ? 1
              : patient.exp_device_use_days === 48
              ? 2
              : patient.exp_device_use_days === 72
              ? 3
              : patient.exp_device_use_days;

          let timePercentage =
            // (hoursDifference / (timeLimit * exp_device)) * 100;
            (hoursDifference / (timeLimit * exp_device)) * 100; // Calculate the percentage of time used
          // *
          // patient.exp_device_use_days
          if (timePercentage > 100) {
            timePercentage = 100; // Limit to 100% if the time exceeds the limit
          }
          // Calculate the completion rate (percentage per hour)
          // Calculate the completion rate (percentage per hour)
          const completionRate = timePercentage / hoursDifference; // percentage per hour

          // Predict the total time to complete 100% (in hours)
          const totalCompletionTime = 100 / completionRate; // in hours

          // Calculate the remaining time to complete (in hours)
          const remainingTimeInHours = totalCompletionTime - hoursDifference;

          // Convert the remaining time to minutes
          const remainingTimeInMinutes = remainingTimeInHours * 60;

          // Convert minutes into hours and minutes
          const hours = Math.floor(remainingTimeInMinutes / 60); // Extract whole hours
          // Get the remaining minutes
          const nowTime = new Date(); // Get the current time
          // Log the current time in IST format
          const istTime = nowTime.toLocaleString("en-US", {
            timeZone: "Asia/Kolkata",
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
          const updatedISTTime = new Date(
            nowTime.getTime() + remainingTimeInMinutes * 60000
          );
          const updatedISTTimeString = updatedISTTime.toLocaleString("en-US", {
            timeZone: "Asia/Kolkata",
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
          // console.log("Current Time in IST:", istTime);
          // console.log("Updated Time in IST:", updatedISTTimeString);

          // Log the predicted remaining time
          // console.log(
          //   `Predicted Remaining Time: ${hours} hours and ${minutes} minutes`
          // );

          // console.log("name", patient.name);
          // console.log("percetage", timePercentage);
          // console.log("timediff", timeDifference);
          // console.log("time limit", timeLimit);

          // Log the result
          // console.log(`Time used: ${hoursDifference.toFixed(2)} hours`);
          // console.log(`Time limit for Priority ${Priority}: ${timeLimit} hours`);
          // console.log(`Percentage of time used: ${timePercentage.toFixed(2)}%`);
          const percentage = timePercentage.toFixed(2);
          // console.log(patient);
          var url = " ";
          if (patient.LastDatasetId != undefined) {
            if (
              patient.backup_status == 0 ||
              patient.backup_status == undefined
            ) {
              url =
                "/verifier-unanalysed/" +
                patient._id +
                "/" +
                patient.LastDatasetId;
            } else {
              url = " ";
            }
          }

          var anl_btn_txt = "teststart";
          var anl_btn_class = "btn-danger";
          var gen_btn_txt = "Not Generated";
          var gen_btn_class = "btn-danger";
          var report_link = "#";
          var report_link_target = "";
          var report_status = patient.report_status;
          window.backup_status = patient.backup_status;
          if (patient.report_status == 1) {
            anl_btn_txt = "Analyzing...";
            anl_btn_class = "btn-success";
          }
          if (patient.report_status >= 2) {
            if (
              patient.backup_status == 0 ||
              patient.backup_status == undefined
            ) {
              url =
                "/verifier-chart/" + patient._id + "/" + patient.LastDatasetId;
              // console.log('percentage!!!!!!!!!!!!!!!!!', patient)
            } else {
              url = " ";
            }
            anl_btn_txt = "test";
            anl_btn_class = "btn-success";
          }
          if (patient.report_status >= 4) {
            gen_btn_txt = "In Preparation";
            gen_btn_class = "btn-yellow";
          }
          if (patient.report_status >= 5) {
            gen_btn_txt = "View Report";
            gen_btn_class = "btn-success";
            report_link_target = "_blank";
          }
          if (patient.report_status == 2) {
            gen_btn_txt = "Not Generated";
            gen_btn_class = "btn-danger";
          }
          if (patient.report_status == 6) {
            gen_btn_txt = "Not Generated";
            gen_btn_class = "btn-danger";
          }
          if (
            patient.backup_status == 0 ||
            patient.backup_status == undefined
          ) {
            anl_btn_txt = "TEST3";
          } else if (patient.backup_status == 1) {
            anl_btn_txt = "Retrieve";
          } else if (patient.backup_status == 2) {
            anl_btn_txt = "Retrieving";
          }
          createdData = patient.created_at.split("T");
          // console.log('patient!!!!!!!!!!!!!!!!!!!!!!!!!!!!!',patient)
          const formattedDate = new Date(
            patient.ConfirmupdatedDate || patient.updatedDate
          ).toLocaleString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
          // comment count for badge
          const cnt = patient.comments ? patient.comments.split("\n").filter(l => l.trim()).length : 0;

          data.rows.push({
            _pid: patient._id,
            _pname: patient.name,
            slno: i + 1,
            patientId: patient.device_id,
            added_date: createdData[0],

            confirmation: patient.Confirmation,
            name: capitalizeFirstLetter(patient.name),
            action: (
              <React.Fragment>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", alignItems: "center", justifyContent: "center" }}>
                  {/* Hide ProgressBtn when report is completed (status 5) */}
                  {patient.report_status !== 5 && (
                    <ProgressBtn
                      id={patient._id}
                      bc_stat={patient.backup_status}
                      onSelectModalComplete={this.handleModalComplete}
                      r_stat={patient.report_status}
                      isPatientListPage={true}
                    />
                  )}
                  {/* ✏️ Edit — icon only, like patient-list */}
                  {(this.state.verifiertype === "8" || this.state.verifiertype === "10") && (
                    <button
                      type="button"
                      id={patient._id}
                      onClick={getInfo}
                      title="Edit Patient"
                      data-toggle="modal"
                      data-target="#editInfoModal"
                      style={{ background: "none", border: "none", padding: "1px 4px", cursor: "pointer", color: "#f0a500", fontSize: "15px", lineHeight: 1 }}
                    >✏️</button>
                  )}
                  {/* ⚙️ Setting — icon only */}
                  <button
                    type="button"
                    id={patient._id}
                    onClick={onClick}
                    title="Settings"
                    data-toggle="modal"
                    data-target="#myModalDHome"
                    style={{ background: "none", border: "none", padding: "1px 4px", cursor: "pointer", fontSize: "16px", lineHeight: 1 }}
                  >⚙️</button>
                  {/* 💬 Comments with count badge */}
                  <button
                    type="button"
                    id={patient._id}
                    onClick={getCommentInfo}
                    title="Comments"
                    data-toggle="modal"
                    data-target="#commentinfomodal"
                    style={{ padding: "1px 7px", fontSize: "11px", height: "22px", background: "#1d4a6e", border: "1px solid #2e6fa3", color: "#fff", borderRadius: "4px", display: "inline-flex", alignItems: "center", gap: 3 }}
                  >
                    💬 <span style={{ fontSize: "10px", background: cnt > 0 ? "#e8f4fd" : "rgba(255,255,255,0.15)", color: cnt > 0 ? "#1a6fa3" : "#aad4f5", borderRadius: 8, padding: "0 4px", fontWeight: 700 }}>{cnt}</span>
                  </button>
                  {/* 🖼 Uploaded ECG images — popup of the patient's phone-uploaded strips */}
                  <button
                    type="button"
                    id={patient._id}
                    title="View uploaded ECG images"
                    onClick={() => this.setState({ stripsUserid: patient.device_id })}
                    style={{ padding: "1px 7px", fontSize: "11px", height: "22px", background: "#1d4a6e", border: "1px solid #2e6fa3", color: "#fff", borderRadius: "4px", display: "inline-flex", alignItems: "center", gap: 3, cursor: "pointer" }}
                  >
                    🖼
                  </button>
                  {/* 📝 Support Notes (Remarks) */}
                  {this.state.verifiertype === "8" && (
                    <button
                      title="Support Notes"
                      style={{ padding: "1px 7px", fontSize: "11px", height: "22px", background: "#2a3a5e", border: "1px solid #4a6aa3", color: "#c8d8f8", borderRadius: "4px", display: "inline-flex", alignItems: "center", gap: 3, cursor: "pointer" }}
                      data-toggle="modal"
                      data-target="#remarksModal"
                      onClick={async () => {
                        try {
                          const response = await axios.get(`${apiUrl}api/common/getIssueRemark?userid=${patient._id}`);
                          this.setState({ user_id: patient._id });
                          this.setState({ remarksText: response.data.data });
                        } catch (err) { console.log(err); }
                      }}
                    >📝 <span style={{ fontSize: "10px" }}>Notes</span></button>
                  )}
                </div>
              </React.Fragment>
            ),
            DistributorName: patient.customerName,

            report: (
              <React.Fragment>
                <div style={{ fontSize: "11px", lineHeight: 1.7 }}>
                <span>
                  <span style={{ color: "#7ab8d8", fontWeight: 600, fontSize: "10px" }}>Created: </span>
                  {this.formatDateStr(patient.ConfirmupdatedDate || patient.updatedDate)}
                </span>
                <br />
                <span>
                  <span style={{ color: "#7ab8d8", fontWeight: 600, fontSize: "10px" }}>Delivered: </span>
                  {patient.mailsentime || patient.whatsappsenttime
                    ? this.formatDateStr(patient.mailsentime || patient.whatsappsenttime)
                    : <span style={{ color: "#888" }}>Not delivered yet</span>}
                </span>
                </div>{/* end date block */}

                {/* ── Buttons row (gap from dates above) ── */}
                <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 6, marginTop: 8 }}>
                {patient.report_status === 5 && (
                  <button
                    type="button"
                    title="View Report"
                    style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "3px 10px", fontSize: "12px", background: "#1a4a2e", border: "1px solid #2ecd99", borderRadius: 5, color: "#2ecd99", cursor: "pointer", fontWeight: 600 }}
                    onClick={() => {
                      try {
                        const formattedName = patient.name.replace(/\s+/g, "_");
                        const reportUrl = `${apiUrl3}assets/dist/user_records/${patient.device_id}/Biocalculus_${formattedName}_${patient.device_id}.pdf`;
                        window.open(reportUrl, "_blank");
                      } catch (error) {
                        window.open(`https://find.mybiocalculus.com/?userid=${patient._id}`, "_blank");
                        console.error("Error opening report link:", error);
                      }
                    }}
                  >
                    <span style={{ fontSize: "15px" }}>📄</span>
                    <span>View Report</span>
                  </button>
                )}
                {patient.report_status !== 5 && (
                  <span style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 8px", fontSize: "11px", background: gen_btn_class === "btn-yellow" ? "rgba(46,205,153,0.12)" : "rgba(220,53,69,0.12)", border: `1px solid ${gen_btn_class === "btn-yellow" ? "#2ecd99" : "#dc3545"}`, borderRadius: 5, color: gen_btn_class === "btn-yellow" ? "#2ecd99" : "#e57373", fontWeight: 600 }}>
                    {gen_btn_class === "btn-yellow" ? "⏳" : "❌"} {gen_btn_txt}
                  </span>
                )}
                {this.state.verifiertype == 8 &&
                  patient.report_status === 5 &&
                  patient.QC === true &&
                  patient.ReportPublished !== "NA" &&
                  patient.Confirmed !== "Yes" && (
                    <button
                      type="button"
                      data-toggle="modal"
                      data-target="#billingModalVH"
                      onClick={() => {
                        const dur = (() => {
                          const n = Number(patient.exp_device_use_days);
                          if (!n) return "";
                          // legacy: stored as days (<24) → convert to hours
                          return String(n < 24 ? n * 24 : n);
                        })();
                        // Doctor name is stored under several variants
                        // across the codebase (see audit). Resolve in this
                        // order: edit-override (with typo) → corrected
                        // typo → lowercase form key → Pascal display →
                        // snake_case state → updatedDoctorname (other
                        // capitalisation) → bare `doctor` field.
                        const fromRow =
                          (patient.updatedDotorName && patient.updatedDotorName !== "NA" && patient.updatedDotorName) ||
                          (patient.updatedDoctorName && patient.updatedDoctorName !== "NA" && patient.updatedDoctorName) ||
                          patient.doctorname ||
                          patient.doctorName ||
                          patient.doctor_name ||
                          patient.updatedDoctorname ||
                          patient.doctor ||
                          "";

                        // Open the modal optimistically with what we already
                        // know, then fire two fetches in parallel:
                        //   1. /alldoctors — populate the dropdown reliably
                        //      (the worker-loaded state.doctors may not be
                        //      ready yet, especially on a slow connection).
                        //   2. /getPatinetAdditionalInfo — pulls the
                        //      authoritative doctor_id + doctor_name for
                        //      THIS patient. Resolves the prefill even if
                        //      the row JSON didn't include any doctor field.
                        this.setState({
                          billingPatient: patient,
                          billingFields: {
                            customerName: patient.customerName || "",
                            ip_op:        patient.ip_op || "",
                            doctorname:   fromRow,
                            duration:     dur,
                            // Optimistic empty — overwritten by the
                            // /getMailidfromDeviceinfo fetch below with
                            // the CUSTOMER (clinic) email + WhatsApp,
                            // since reports are shared to the customer,
                            // not the patient.
                            mailReport:   "",
                            whatsapp:     "",
                          },
                        });

                        // Load this customer's customisation notes for the modal
                        this.fetchCustomerComments(patient.customerName || "");

                        // Refresh doctor list (cheap; fine to re-fetch every open).
                        axios
                          .get(`${apiUrl}api/users/alldoctors`)
                          .then((res) => {
                            if (Array.isArray(res.data) && res.data.length) {
                              this.setState({ doctors: res.data });
                            }
                          })
                          .catch(() => { /* silent — fall back to worker-loaded doctors */ });

                        // Fetch customer-side contacts (clinic email +
                        // WhatsApp) from the device record — same call
                        // the existing Send Report button uses at line ~926.
                        // The trailing "000000000" matches the existing
                        // route signature; deviceInfo.mail is the clinic
                        // email the report is shared to.
                        if (patient.device_id) {
                          axios
                            .get(`${apiUrl}api/users/getMailidfromDeviceinfo/${patient.device_id}000000000`)
                            .then((res) => {
                              const di = (res.data && res.data.deviceInfo) || {};
                              this.setState((prev) => ({
                                billingFields: {
                                  ...prev.billingFields,
                                  mailReport: di.mail     || prev.billingFields.mailReport || "",
                                  whatsapp:   di.whatsapp || prev.billingFields.whatsapp   || "",
                                },
                              }));
                            })
                            .catch(() => { /* silent — fields stay editable */ });
                        }

                        // Patch in the current doctor if the row JSON didn't have one.
                        if (!fromRow && patient._id) {
                          axios
                            .get(`${apiUrl}api/patients/getPatinetAdditionalInfo?userid=${patient._id}`)
                            .then((res) => {
                              const data = (res.data && res.data[0]) || {};
                              const resolved =
                                data.doctor_name ||
                                data.doctorName ||
                                data.doctorname ||
                                "";
                              if (resolved) {
                                this.setState((prev) => ({
                                  billingFields: { ...prev.billingFields, doctorname: resolved },
                                }));
                              }
                            })
                            .catch(() => { /* silent — user can pick from dropdown */ });
                        }
                      }}
                      style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "3px 10px", fontSize: "12px", background: "#0a8aa0", border: "none", borderRadius: 5, color: "#ffffff", cursor: "pointer", fontWeight: 600, height: "auto" }}
                    >
                      💰 Add Billing
                    </button>
                  )}
                {this.state.verifiertype == 8 &&
                  patient.report_status === 5 &&
                  patient.QC === true &&
                  patient.ReportPublished !== "NA" &&
                  patient.Confirmed === "Yes" && (
                    <button
                      style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "3px 10px", fontSize: "12px", background: "#1a3a52", border: "1px solid #3a8abf", borderRadius: 5, color: "#6ac8f5", cursor: "pointer", fontWeight: 600, height: "auto" }}
                      type="button"
                      id={patient._id}
                      onClick={async () => {
                        // Clinic contacts come from the device_info. The route
                        // now always returns a deviceInfo object (blank fields
                        // when it can't resolve the mac), so the popup opens
                        // even with no contact on file. If the call itself
                        // fails, surface it (toast) but still open the popup
                        // with editable blanks.
                        let deviceInfo = {};
                        try {
                          const response = await axios(
                            `${apiUrl}api/users/getMailidfromDeviceinfo/${patient.device_id}000000000`
                          );
                          deviceInfo = (response.data && response.data.deviceInfo) || {};
                        } catch (e) {
                          toast.error("Could not load device contacts — enter email / WhatsApp manually.");
                        }

                        // Customer fields come from the device_info (clinic
                        // contacts). Patient fields come from the Patient
                        // doc itself — registration number = device_id,
                        // patient WhatsApp = patient.phone, patient email =
                        // patient.email (falls back to clinic email if the
                        // patient record doesn't have one).
                        this.setState({
                          mailuserid: patient._id,
                          device_id: patient.device_id,
                          patientName: patient.name,
                          patientNameForShare: patient.name || "",
                          patientRegNumber: String(patient.device_id || ""),
                          mailsubject: `${patient.name} Biocalculus: ${patient.device_id}`,
                          customermailid: deviceInfo.mail || "",
                          device_mac: deviceInfo.mac_id || "",
                          whatsappNumber: deviceInfo.whatsapp || "",
                          patientmailsubject: `${patient.name} Biocalculus: ${patient.device_id}`,
                          // Patient mail: ONLY use the patient's own email.
                          // If the patient doc has no email, leave the field
                          // blank — staff can type one in. Do NOT fall back
                          // to the customer/clinic email; that was sending
                          // patient reports to the clinic inbox.
                          patientmailid: patient.email || "",
                          // Patient WhatsApp: prefer the patient's phone;
                          // fall back to clinic whatsapp (intentional — same
                          // device often carries reports for both).
                          patientwhatsappNumber: patient.phone || deviceInfo.whatsapp || "",
                        });
                        const formatDate = (date) => {
                          let dd = String(date.getDate()).padStart(2, "0");
                          let mm = String(date.getMonth() + 1).padStart(2, "0");
                          let yyyy = date.getFullYear();
                          let hrs = String(date.getHours()).padStart(2, "0");
                          let min = String(date.getMinutes()).padStart(2, "0");
                          return `${yyyy}-${mm}-${dd}T${hrs}:${min}`;
                        };
                        const Priority =
                          patient.priority !== undefined && patient.priority !== null && patient.priority !== "" && Number(patient.priority) > 0
                            ? Number(patient.priority)
                            : (deviceInfo && deviceInfo.Priority) || 4;
                        let finalTime;

                        if (patient.ConfirmupdatedDate) {
                          let confirmButtonTime =
                            patient.ConfirmupdatedDate.split("T");
                          let confirmDate = confirmButtonTime[0];
                          let confirmTime = confirmButtonTime[1]
                            ? confirmButtonTime[1].split("Z")[0]
                            : "";
                          if (confirmTime) {
                            let time = confirmTime.split(".")[0];
                            finalTime = confirmDate + " " + time;
                          }
                        }

                        if (patient.updatedDate && !finalTime) {
                          let updatedDateTime = patient.updatedDate.split(" ");
                          let updatedDate = updatedDateTime[0];
                          let updatedTime = updatedDateTime[1];
                          finalTime = updatedDate + " " + updatedTime;
                        }

                        const now = new Date();
                        const finalDate = new Date(finalTime);
                        const timeDifference = now - finalDate;
                        const hoursDifference =
                          timeDifference / (1000 * 60 * 60);

                        let timeLimit;
                        switch (Priority) {
                          case 1:
                            timeLimit = 1;
                            break;
                          case 2:
                            timeLimit = 2;
                            break;
                          case 3:
                            timeLimit = 3;
                            break;
                          case 4:
                            timeLimit = 4;
                            break;
                          case 5:
                            timeLimit = 5;
                            break;
                          default:
                            timeLimit = 4;
                        }

                        const timeLimitHours =
                          timeLimit * patient.exp_device_use_days;
                        let timePercentage =
                          (hoursDifference / timeLimitHours) * 100;
                        if (timePercentage > 100) timePercentage = 100;

                        const completionRate = timePercentage / hoursDifference;
                        const totalCompletionTime = 100 / completionRate;
                        const remainingTimeInHours =
                          totalCompletionTime - hoursDifference;
                        const remainingTimeInMilliseconds =
                          remainingTimeInHours * 60 * 60 * 1000;
                        const completionDate = new Date(
                          now.getTime() + remainingTimeInMilliseconds
                        );
                        this.setState({
                          setCompletionDate: formatDate(completionDate),
                        });
                        // console.log(
                        //   "getmailscheduletime!!!!!!!!!!!!!!!!!!!!!!!!!!!",
                        //   this.state.setCompletionDate
                        // );
                      }}
                      data-toggle="modal"
                      data-target="#mailinfomodal"
                    >
                      ✉️ Send Report
                    </button>
                  )}
                {patient.mailsentime && (
                  <span
                    title={`Mail sent: ${patient.mailsentime}`}
                    onClick={() => toast(`Report shared via mail: ${patient.mailsentime}`)}
                    style={{ display: "inline-flex", alignItems: "center", cursor: "pointer", marginLeft: 4 }}
                  >
                    <img
                      src="../../../gmail.png"
                      alt="Mail Sent"
                      style={{ width: 18, height: 18, objectFit: "contain" }}
                    />
                  </span>
                )}
                {patient.whatsappsenttime && (
                  <span
                    title={`WhatsApp sent: ${patient.whatsappsenttime}`}
                    onClick={() => toast(`Report shared via WhatsApp: ${patient.whatsappsenttime}`)}
                    style={{ display: "inline-flex", alignItems: "center", cursor: "pointer", marginLeft: 4 }}
                  >
                    <img
                      src="../../../whatsapp icon.png"
                      alt="WhatsApp Sent"
                      style={{ width: 18, height: 18, objectFit: "contain" }}
                    />
                  </span>
                )}{" "}
                </div>{/* end buttons row */}
                <input type="hidden" className="patientLink" value={url} />
              </React.Fragment>
            ),
          });
        }, this);
        this.setState({ data, columns: data.columns, rows: data.rows, loading: false });
      })
      .catch((err) => { this.setState({ loading: false, loadingMore: false }); });

    $(document).ready(function () {
      $("#mbdTable").on("click", "tr td:nth-child(2)", function () {
        var url = $(this).parent().find(".patientLink").val();
        if (url != " ") {
          window.location.href = url;
          // console.log("url");
        }
      });
      $("#mbdTable").on("click", "tr td:nth-child(3)", function () {
        var url = $(this).parent().find(".patientLink").val();
        if (url != " ") {
          window.location.href = url;
          // console.log("url:", url);
        }
      });
      $("#mbdTable").on("click", "tr td:nth-child(4)", function () {
        var url = $(this).parent().find(".patientLink").val();
        if (url != " ") {
          window.location.href = url;
          // console.log("url");
        }
      });
    });
  };
  handleVerifierChange = (selectedOptions) => {
    this.setState({
      selectedVerifiers: selectedOptions || [], // Update selected verifiers or set empty array if none
    });
    // console.log('selected options',selectedOptions)
    // console.log('selected verifier state',this.state.selectedVerifiers,this.state.selectedVerifierIds)
  };
  handleConfirmationClick(patientId, confirmation) {
    // console.log(this.state.patients);
    this.setState({
      isConfirmationModalOpen: true,
      selectedPatientId: patientId,
      selectedConfirmation: confirmation,
    });
  }

  handleConfirmationChange(event) {
    this.setState({ selectedConfirmation: event.target.value });
  }

  handleConfirmationSubmit() {
    const { selectedPatientId, selectedConfirmation } = this.state;
    // Handle the submit action, e.g., make an API call to update the confirmation status
    axios
      .post(`${apiUrl}api/patients/updateConfirmation`, {
        userid: selectedPatientId,
        Confirmation: selectedConfirmation,
      })
      .then((response) => {
        // console.log("Confirmation updated:", response.data);
        this.setState({ isConfirmationModalOpen: false });

        toast.success(`Confirmation Updated to : ${selectedConfirmation}`);
        this.fetchData(); // Refresh the data after updating confirmation
      })
      .catch((error) => {
        console.error("Error updating confirmation:", error);
      });
  }

  handleConfirmationCancel() {
    this.setState({ isConfirmationModalOpen: false });
    // console.log('cancel')
  }

  submitIssueReported = async (e) => {
    const userid = this.state.user_id;
    // console.log('userid', userid)
    const issueReported = this.state.remarksText;
    const reponse = await axios.post(
      `${apiUrl}api/patients/update_issue_remark`,
      { remarks: issueReported, userid: this.state.user_id }
    );
    // console.log(reponse.data);
  };
  // Instant comment load — reads directly from already-fetched patients array
  getCommentInfo = (e) => {
    const userid = e.currentTarget.id;
    this.setState({ userid });
    const patient = (this.state.patients || []).find(p => p._id === userid);
    if (patient) {
      this.setState({
        comments: patient.comments || "",
        patient_name: patient.name || "",
      });
    }
  };

  submitComment = async (e) => {
    const userid = e.currentTarget.id;
    const newText = (this.state.newComment || "").trim();
    if (!newText) return;
    const verifiername = localStorage.getItem("verifiername") || "Unknown";
    const timestamp = new Date().toLocaleString("en-IN", {
      day: "2-digit", month: "short",
      hour: "2-digit", minute: "2-digit", hour12: true,
    });
    const newEntry = `${newText} — ${verifiername} [${timestamp}]`;
    // Append to existing history instead of replacing
    const existing = (this.state.comments || "").trim();
    const comments = existing ? `${existing}\n${newEntry}` : newEntry;
    try {
      await axios.post(`${apiUrl}api/patients/addComment/${userid}`, { comments });
      $(".closePopup").click();
      this.setState({ newComment: "", comments: "" });
      this.fetchData(); // refresh badge counts
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };
  validateEmails = (emails) => {
    const emailList = emails.split(",").map((email) => email.trim());
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailList.every((email) => emailRegex.test(email));
  };

  validateWhatsAppNumbers = (numbers) => {
    if (!numbers) return false;
    const numberList = numbers.split(",").map((num) => num.trim());
    const phoneRegex = /^\d{10}$/;

    // If it's a previously saved number that might have a different format
    if (numberList.length === 1 && this.state.device_id) {
      return true; // Trust previously saved numbers
    }

    return numberList.every((num) => {
      // Remove any non-digit characters for validation
      const digitsOnly = num.replace(/\D/g, "");
      return phoneRegex.test(digitsOnly);
    });
  };

  sentMailReport = async (e) => {
    const mailid = this.state.customermailid;
    const userid = this.state.mailuserid;

    if (!userid || !mailid) {
      toast.error("Enter Email ID to proceed");
      return;
    }

    if (!this.validateEmails(mailid)) {
      toast.error(
        "Please enter valid email address(es). Use commas to separate multiple emails."
      );
      return;
    }

    // var apiUrl = `${apiUrl}api/users/sendmailReport_new_new_Read_Schedule`;

    var requestBody = {
      userid: userid,
      mailid: mailid,
      mailsubject:
        this.state.mailsubject ||
        `${this.state.patientName}: Biocalculus: ${this.state.device_id}`,
      scheduledTime: this.state.setCompletionDate, // Add scheduled time for customer
    };

    await axios.post(`${apiUrl}api/users/updateMailId`, {
      mailid: this.state.customermailid,
      mac_id: this.state.device_mac,
      phone: this.state.whatsappNumber,
      device_id: this.state.device_id,
    });

    fetch(
      `${apiUrl}api/users/sendmailReport_new_new_Read_Schedule_New_path`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      }
    )
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok)
            throw new Error(data.message || "Failed to send email.");
          return data;
        })
      )
      .then((data) => {
        // Scheduled ≠ delivered — don't show it as a success / sent icon.
        if (data && data.status === "scheduled") {
          toast(data.message || "Report scheduled — not yet delivered.", { icon: "🕒" });
        } else {
          toast.success(data.message || "Mail sent successfully.");
          this.fetchData(); // refresh so the mail-sent icon reflects real delivery
        }
        $(".closePopup").click();
        this.setState({ customermailid: "", whatsappNumber: "", mailid: "" });
      })
      .catch((error) => {
        toast.error("Mail not delivered: " + (error.message || "unknown error"));
      });
  };

  // Two-stage save: (1) persist edited customer/doctor/duration/etc.
  // via /updateSharedDetails, then (2) flip Confirmed→"Yes" via
  // /confirmBilling. Same endpoints ReportPatientsList uses, so state
  // stays in sync across pages and billing is naturally linked to the
  // customer (patient.customerName). Admin-verifier only.
  markBilling = async () => {
    const bp = this.state.billingPatient;
    if (!bp || !bp._id) return;
    this.setState({ markingBilling: true });
    const ConfirmedBy = localStorage.getItem("verifiername") || "Verifier";
    const f = this.state.billingFields;
    try {
      // 1. Save edited fields (customer, doctor, duration, etc.)
      await axios.post(apiUrl + "api/patients/updateSharedDetails", {
        userid:       bp._id,
        doctorname:   f.doctorname,
        ipop:         f.ip_op,
        customerName: f.customerName,
        duration:     f.duration,
        mailReport:   f.mailReport,
        whatsapp:     f.whatsapp,
      });
      // 2. Confirm billing
      await axios.post(apiUrl + "api/patients/confirmBilling", {
        userid:      bp._id,
        Confirmed:   "Yes",
        ConfirmedBy: ConfirmedBy,
      });
      this.setState({
        markingBilling: false,
        billingPatient: null,
      });
      toast.success("Details saved and billing confirmed.");
      this.fetchData();
    } catch (err) {
      this.setState({ markingBilling: false });
      toast.error(
        "Failed: " +
        (err.response ? err.response.status : err.message)
      );
    }
  };

  handleBillingFieldChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      billingFields: { ...prev.billingFields, [name]: value },
    }));
    // Switching customer inside the modal → load that customer's notes
    if (name === "customerName") {
      this.fetchCustomerComments(value);
    }
  };

  // Load the customisation notes stored on the customer's user record.
  fetchCustomerComments = (customerName) => {
    const name = (customerName || "").trim();
    if (!name || name.toUpperCase() === "NA") {
      this.setState({ billingCustomerComments: "" });
      return;
    }
    axios
      .get(`${apiUrl}api/users/getCustomerComments`, { params: { name } })
      .then((res) => {
        this.setState({
          billingCustomerComments: (res.data && res.data.comments) || "",
        });
      })
      .catch(() => this.setState({ billingCustomerComments: "" }));
  };

  saveCustomerComments = () => {
    const name = (this.state.billingFields.customerName || "").trim();
    if (!name) {
      toast.error("Select a customer first");
      return;
    }
    this.setState({ billingCommentsSaving: true });
    axios
      .post(`${apiUrl}api/users/updateCustomerComments`, {
        name,
        comments: this.state.billingCustomerComments,
      })
      .then(() => {
        toast.success("Customer comments saved");
        this.setState({ billingCommentsSaving: false });
      })
      .catch((err) => {
        toast.error(
          "Save failed: " + (err.response ? err.response.status : err.message)
        );
        this.setState({ billingCommentsSaving: false });
      });
  };

  sentWhatsappReport = async (e) => {
    const number = this.state.whatsappNumber;
    const userid = this.state.mailuserid;
    const arrythymia = this.state.arrythymia || "NA";

    if (!arrythymia || !number) {
      toast.error("Enter WhatsApp number to proceed");
      return;
    }

    if (!this.validateWhatsAppNumbers(number)) {
      toast.error(
        "Please enter valid 10-digit WhatsApp number(s). Use commas to separate multiple numbers."
      );
      return;
    }

    // var apiUrl = `${apiUrl}api/common/schedule_whatsapp`;

    var requestBody = {
      user_id: userid,
      arrythymia: arrythymia,
      number: number,
      scheduledTime: this.state.setCompletionDate,
    };

    fetch(`${apiUrl}api/common/schedule_whatsapp_New`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    })
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok)
            throw new Error(data.message || "Failed to send WhatsApp message.");
          return data;
        })
      )
      .then((data) => {
        // Scheduled ≠ delivered — don't show it as a success / sent icon.
        if (data && data.status === "scheduled") {
          toast(data.message || "WhatsApp scheduled — not yet delivered.", { icon: "🕒" });
        } else {
          toast.success(data.message || "WhatsApp message sent successfully!");
          this.fetchData(); // refresh so the WhatsApp-sent icon reflects real delivery
        }
        this.setState({
          customermailid: "",
          whatsappNumber: "",
          mailid: "",
          arrythymia: "",
        });
        $(".closePopup").click();
      })
      .catch((error) => {
        toast.error(
          "WhatsApp not delivered: " + (error.message || "unknown error")
        );
      });
  };
  sentMailReportPatient = async (e) => {
    const mailid = this.state.patientmailid;
    const userid = this.state.mailuserid;

    if (!userid || !mailid) {
      toast.error("Enter Email ID to proceed");
      return;
    }

    // var apiUrl = `${apiUrl}api/users/sendmailReport_new_new_Read_Schedule_cron`;

    var requestBody = {
      userid: userid,
      mailid: mailid,
      mailsubject:
        this.state.patientmailsubject ||
        `${this.state.patientName}: Biocalculus: ${this.state.device_id}`,
      scheduledTime: this.state.setCompletionDate, // Add scheduled time for patient
    };

    fetch(
      `${apiUrl}api/users/sendmailReport_new_new_Read_Schedule_New_path`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      }
    )
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok)
            throw new Error(data.message || "Failed to send email.");
          return data;
        })
      )
      .then((data) => {
        if (data && data.status === "scheduled") {
          toast(data.message || "Report scheduled — not yet delivered.", { icon: "🕒" });
        } else {
          toast.success(data.message || "Mail sent successfully!");
          this.fetchData();
        }
        $(".closePopup").click();
      })
      .catch((error) => {
        toast.error("Mail not delivered: " + (error.message || "unknown error"));
      });
  };

  sentWhatsappReportPatient = async (e) => {
    const number = this.state.patientwhatsappNumber;
    const userid = this.state.mailuserid;
    const arrythymia = this.state.arrythymia || "NA";

    if (!arrythymia || !number) {
      toast.error("Enter WhatsApp number to proceed");
      return;
    }

    if (!this.validateWhatsAppNumbers(number)) {
      toast.error(
        "Please enter valid 10-digit WhatsApp number(s). Use commas to separate multiple numbers."
      );
      return;
    }

    // var apiUrl = `${apiUrl}api/common/schedule_whatsapp`;

    var requestBody = {
      user_id: userid,
      arrythymia: arrythymia,
      number: number,
      scheduledTime: this.state.setCompletionDate, // Add scheduled time for patient
    };

    fetch(`${apiUrl}api/common/schedule_whatsapp_New`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    })
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok)
            throw new Error(data.message || "Failed to send WhatsApp message.");
          return data;
        })
      )
      .then((data) => {
        if (data && data.status === "scheduled") {
          toast(data.message || "WhatsApp scheduled — not yet delivered.", { icon: "🕒" });
        } else {
          toast.success(data.message || "WhatsApp message sent successfully!");
          this.fetchData();
        }
      })
      .catch((error) => {
        toast.error(
          "WhatsApp not delivered: " + (error.message || "unknown error")
        );
      });
  };

  handleModalComplete(id) {
    // console.log("id:", id);
    this.state.userid = id;
    // Patient name rides along so "+ Queue" in the analyze modal can show
    // a readable entry in the analysis-queue panel.
    const row = (this.state.rows || []).find((r) => r._pid === id);
    this.setState({
      isModalCompleteOpen: true,
      patientName: (row && row._pname) || this.state.patientName,
    });
  }
  onSubmit = (e) => {
    e.preventDefault();

    const settings = {
      userid: this.state.userid,
      nor_minhr: this.state.nor_minhr,
      nor_maxhr: this.state.nor_maxhr,
      qtcformula: this.state.qtcformula,
      qtcvalue_min: this.state.qtcvalue_min,
      qtcvaluemax: this.state.qtcvaluemax,
      qrswidth_min: this.state.qrswidth_min,
      qrswidth_max: this.state.qrswidth_max,
      qrsamp_min: this.state.qrsamp_min,
      qrsamp_max: this.state.qrsamp_max,
      stelevation: this.state.stelevation,
      pwidth_min: this.state.pwidth_min,
      pwidth_max: this.state.pwidth_max,
      pamp_min: this.state.pamp_min,
      pamp_max: this.state.pamp_max,
      stdepression: this.state.stdepression,
      twidth_min: this.state.twidth_min,
      twidth_max: this.state.twidth_max,
      tamp_min: this.state.tamp_min,
      tamp_max: this.state.tamp_max,
      printerval_min: this.state.printerval_min,
      printerval_max: this.state.printerval_max,
      tachyhr_lower: this.state.tachyhr_lower,
      tachyhr_upper: this.state.tachyhr_upper,
      bradyhr_lower: this.state.bradyhr_lower,
      bradyhr_upper: this.state.bradyhr_upper,
      pauselength: this.state.pauselength,
      graph_gen: this.state.graph_gen,
    };

    // console.log(settings);
    axios
      .post(apiUrl + "api/patients/updateSettings", settings)
      .then((res) => {
        $("#closePopup").click();
        // console.log("onclick");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  onSubmitInfo = (e) => {
    e.preventDefault();

    //   this.state.selectedVerifiers.forEach(verifier => {
    //     console.log("Verifier ID:", verifier.value);
    // });

    const info = {
      name: this.state.patient_name,
      patientid: this.state.userid,
      userid: this.state.userid,
      dob: this.state.dob,
      weight: this.state.weight,
      height: this.state.height,
      hospital: this.state.hospital,
      phone: this.state.phone,
      email: this.state.email_id,
      doctorid: this.state.selectedDoctor.value,
      ipop: this.state.ipop,
      fileType: this.state.filetype || "easy",
      verifierid: this.state.selectedVerifiers.map(
        (verifier) => verifier.value
      ),
      priority: this.state.priority,

      reportstatus: this.state.reportstatus,
      // smoking: this.state.smoking,
      // diabetes: this.state.diabetes,
      af: this.state.af,
      // hyper_tension: this.state.hyper_tension,
      // hyper_lipidemia: this.state.hyper_lipidemia,
      hyper_lipidemia: this.state.pacemaker,
      indication: this.state.indication,
      cardiac_surgery: this.state.cardiac_surgery,
      thyroid: this.state.thyroid_function,
      exp_device_use_days: this.state.duration,
      issueReported: this.state.issueReport,
      supportLevel: this.state.supportLevel,
      supportPerson: this.state.supportPerson,
      supportcomment: this.state.supportedMatter,
      selectedLabels: this.state.selectedLabels.map((label) => label.value),
      prioritizeData: this.state.prioritizeData, // <-- Add this line
      clinicalCondition: this.state.clinicalCondition, // <-- Add this line
    };
    // Customer: sent only when changed in the dropdown, so saving the modal
    // never overwrites a customer the user did not touch.
    const editCustomer = this.state.editCustomer;
    if (editCustomer && editCustomer.value !== this.state.editCustomerOriginal) {
      info.customerName = editCustomer.value;
      info.customerId = editCustomer.customerId || "";
    }
    // console.log("info:", this.state.clinicalCondition);

    const deviceinfoupdate = {
      mac_id: this.state.macid,
      priority: this.state.priority,
    };

    axios
      .post(apiUrl + "api/patients/updateInfo_new_info_test", info)
      .then((res) => {
        // Handle the response of the first request
        // console.log("Patient info updated:", res.data);
        if (this.state.macid != null) {
          // If macid is either undefined or null
          return axios.put(
            `${apiUrl}api/patients/updateDevicePriority`,
            deviceinfoupdate
          );
        }
      })

      .then((res) => {
        // Handle the response of the second request
        // console.log("Device priority updated:", res.data);
        $(".closePopup").click();
        this.fetchData(); // Fetch updated data
      });
    axios
      .post(`${apiUrl}api/common/updateMarkedLabel`, {
        userid: this.state.userid,
        MarkedLabel: this.state.selectedLabels.map((label) => label.value),
      })
      .then((res) => {
        // console.log("MarkedLabel", res.data);
      })
      .catch((err) => {
        // Handle any errors from either request
        console.error("Error occurred:", err);
      });
  };

  onChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    // console.log("onChange");
    // console.log(e.target.name);
    // console.log(e.target.value);
    // console.log(e.target)
    // this.setState({reportstatus:e.target.value})
    // console.log(e.target.value)

    this.setState({ [e.target.name]: e.target.value });
  };
  onDurationChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    this.setState({ duration: e.target.value });
    // console.log(this.state.duration);
  };
  onPriorityChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];

    this.setState({ priority: e.target.value });
    // console.log(this.state.priority);
  };
  onReportStatuschange = (e) => {
    // console.log("report stats change",e.target.value)
    this.setState({ reportstatus: e.target.value });
  };

  preventDefault(e) {
    e.preventDefault();
  }

  getInfo(e) {
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      loadingEditModal: true, // Set loading to true when starting
      supportPerson: "",
      supportLevel: "",
      supportedMatter: "",
      editCustomer: null,
      editCustomerOriginal: "",
    });
    this.setState({ isModalCompleteOpen: false });
    var userid = e.currentTarget.id;

    // Customer dropdown: start from the customer shown on the patient row.
    // It may be a name or a WCN id; match either to a registered customer.
    if (!(this.state.customerOptions || []).length) this.fetchCustomerOptions();
    const rowPatient = (this.state.patients || []).find((p) => p._id === userid);
    const curCustomer = String((rowPatient && rowPatient.customerName) || "").trim();
    if (curCustomer && curCustomer.toUpperCase() !== "NA") {
      const key = curCustomer.toLowerCase();
      const match = (this.state.customerOptions || []).find(
        (o) => o.value.toLowerCase() === key || (o.customerId && o.customerId.toLowerCase() === key)
      );
      this.setState({
        editCustomer: match || { value: curCustomer, label: curCustomer, customerId: "" },
        editCustomerOriginal: curCustomer,
      });
    }
    const dataid2 = e.target.getAttribute("dataid2");
    const dataid3 = e.target.getAttribute("dataid3");
    this.setState({ userid: userid });

    // Always refresh doctor list when the Edit modal opens. The mount-
    // time worker fetch (line ~384) can silently fail (worker-loader
    // hiccup in dev, race with first render, etc.), leaving state.doctors
    // empty so the Doctor dropdown shows nothing. A direct axios call
    // here guarantees the dropdown is populated by the time the user
    // looks at it. Only updates state if the response is a non-empty
    // array — never poisons state.doctors with bad data.
    axios
      .get(`${apiUrl}api/users/alldoctors`)
      .then((res) => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          this.setState({ doctors: res.data });
        }
      })
      .catch((err) => {
        console.warn("[getInfo] /alldoctors fetch failed:", err && err.message);
      });

    axios
      .get(`${apiUrl}api/patients/getPatinetAdditionalInfo?userid=${userid}`)
      .then((res) => {
        const data = res.data[0];
        if (
          data.gender === "MALE" ||
          data.gender === "male" ||
          data.gender === "Male" ||
          data.gender === "M" ||
          data.gender === "m"
        ) {
          this.setState({ gender: "M" });
        }

        if (
          data.gender === "FEMALE" ||
          data.gender === "female" ||
          data.gender === "Female" ||
          data.gender === "F" ||
          data.gender === "f"
        ) {
          this.setState({ gender: "F" });
        }
        if (data.gender === "Select Gender") {
          this.setState({ gender: "M" });
        }

        if (Array.isArray(this.state.patients)) {
          this.state.patients.forEach((patient) => {
            if (patient._id === userid) {
              this.setState({ reportstatus: patient.report_status });
              // console.log("report status", patient.report_status);
            }
          });
        }
        data.customer_details.forEach((customer) => {
          if (customer.customer_details) {
            // console.log('Nested Customer Details:', customer);
            this.setState({ customer_details: customer.customer_details });
          }
        });
        // console.log(this.state.patients);
        console.log("additional data!!!!!!!!!!!!!!!", data);
        // Sanitize DOB before the first setState. The raw API value can
        // be null / "" / "0001-01-01" / a near-epoch garbage date that
        // gets resolved to 1971-06-21 by JS — feeding any of those into
        // react-datetime's setViewDate throws "Invalid date" mid-render,
        // which aborts the rest of the tree (including the doctor
        // dropdown) → blank Edit modal.
        let safeDob = "";
        if (data.dob) {
          const _d = new Date(data.dob);
          // Reject NaN and any year < 1900 (the typical "epoch leak"
          // failure mode lands at 1969-1971).
          if (!isNaN(_d.getTime()) && _d.getFullYear() >= 1900) {
            const mm = String(_d.getMonth() + 1).padStart(2, "0");
            const dd = String(_d.getDate()).padStart(2, "0");
            const yyyy = _d.getFullYear();
            safeDob = `${mm}/${dd}/${yyyy}`;
          }
        }

        // Update state with patient info
        this.setState({
          af: data.af ? "yes" : "no",
          duration: data.exp_device_use_days,
          cardiac_surgery: data.cardiac_surgery ? "yes" : "no",
          thyroid_function: data.thyroid,
          diabetes: data.diabetes,
          indication: data.indication,
          height: data.height,
          weight: data.weight,
          hospital: data.hospital,
          phone: data.phone,
          patient_name: data.name,
          email_id: data.email,
          selectedDoctor: { value: data.doctor_id, label: data.doctor_name },
          macid: dataid2,
          priority: dataid3,
          // Use the sanitized value, NOT data.dob — prevents the
          // setViewDate crash described above.
          dob: safeDob,
          duration: data.exp_device_use_days,
          filetype: data.fileType,
          pacemaker: data.hyper_lipidemia,
          issueReport: data.issueReported,
          Confirmation: data.Confirmation,
          supportedMatter: data.supportcomment,
          supportPerson: data.supportPerson,
          supportLevel: data.supportLevel,
          prioritizeData: data.priorityStatus || "No",
          clinicalCondition: data.clinicalCondition || "", // <-- Add this line
        });
        if (data.MarkedLabel) {
          const selectedLabels = data.MarkedLabel.map((label) => ({
            value: label,
            label: label,
          }));
          this.setState({ selectedLabels });
        }
        // (Removed the redundant second setState for dob — safeDob was
        // already applied above. The previous code set dob twice — raw
        // then formatted — leaking the bad raw value to react-datetime
        // for one render cycle before the cleanup landed.)
        // console.log("Formatted DOB:", this.state.dob);

        // Second API call for verifiers
        return axios.get(`${apiUrl}api/users/allverifiers`);
      })
      .then((res) => {
        const verifiers = res.data;
        const formattedVerifiers = verifiers.map((verifier) => ({
          value: verifier._id,
          label: verifier.name,
          patients: verifier.patients, // Assuming patients is an array of user IDs
        }));

        const filteredVerifiers = formattedVerifiers.filter((verifier) =>
          verifier.patients.includes(userid)
        );

        // console.log('Filtered verifiers with matching user:', this.state.priority);

        this.setState({ selectedVerifiers: filteredVerifiers });

        this.setState({ verifiers: formattedVerifiers });
        // console.log('formatted verifiers:',verifiers)
        // Third API call for patient search (ipop)
        this.state.patients.forEach((patient) => {
          if (patient._id === userid) {
            this.setState({ comments: patient.comments });
            // this.setState({ priority: patient.priority });
            this.setState({ ipop: patient.ip_op });
          }
        });

        // console.log("ipop", this.state.patients);

        // Fourth API call for verified percentage
        return axios.get(`${apiUrl}api/users/getVerifiedPercentage/${userid}`);
      })
      .then((res) => {
        const ecgValues = res.data.ecgValues; // Assuming `ecgValues` is an array
        const totalLength = ecgValues.length;
        let verifyCount = 0; // Initialize verify count

        ecgValues.forEach((value, index) => {
          if (value.verifyStatus === 1) {
            // console.log(`Link for ECG value at index ${index}:`, value.link); // Assuming there's a 'link' property
            verifyCount++; // Increment the verify count
          }
        });

        // console.log('Total verified ECG values:', verifyCount);
        // console.log('Total count:', totalLength);

        if (totalLength > 0) {
          // console.log('ECG data is available.');

          // Calculate and log the percentage of verified ECG values
          const percentageVerified = (verifyCount / totalLength) * 100;
          // console.log('Percentage of verified ECG values:', percentageVerified.toFixed(2) + '%');
          this.setState({ percentageVerified: percentageVerified.toFixed(2) });
          // console.log('verified percentage:',this.state.percentageVerified)
        } else {
          // console.log('No ECG data found.');
        }
        this.setState({ loadingEditModal: false }); // Data loaded, hide spinner
        axios.get(`${apiUrl}api/common/getSupportPerson`).then((res) => {
          if (res.data && Array.isArray(res.data)) {
            this.setState({ supportPersons: res.data });
            // console.log("support persons:!!!!!!!!!!!!!!!!!!!!!!", this.state.supportPersons);
          }
        });
      })

      .catch((error) => {
        console.error("Error fetching ECG data:", error);
        this.setState({ loadingEditModal: false }); // Hide spinner on error
      });
  }

  selectItem(e) {
    var userid = e.currentTarget.id;
    this.setState({ userid: userid });
    this.setState({
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      tamp_min: "",
      tamp_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
    });
    axios
      .get(apiUrl + "api/patients/settings?userid=" + userid)
      .then((res) => {
        var data = res.data;
        this.setState(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  resetInfoModal() {
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      customer_details: "", // Reset customer details too
      reportstatus: "",
      dob: "",
      height: "",
      weight: "",
      hospital: "",
      phone: "",
      patient_name: "",
      email_id: "",
      doctor_name: "",
      doctor_id: "",
      duration: "",
      selectedVerifiers: [],
      verifiers: [],
      comments: "",
      priority: "",
      ipop: "",
      percentageVerified: "",
      selectedLabels: [],
      currentEditUserId: null, // Reset currentEditUserId
      editCustomer: null,
      editCustomerOriginal: "",
      loadingEditModal: false, // Reset loading state
    });
    // console.log(this.state.verifiers);
  }
  filterRows = () => {
    const { rows, searchQuery } = this.state;

    if (!searchQuery) {
      return rows; // If no search query, return all rows
    }

    return rows.filter((row) => {
      // You can modify this to check specific fields for a match
      return Object.values(row).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(searchQuery.toLowerCase())
      );
    });
  };
  handleSearchChange = (e) => {
    const value = e.target.value;
    // Search now runs on the SERVER across ALL patients (not just the loaded
    // batch), so a match is found even if it wasn't loaded yet. Debounced so
    // we don't fire a request on every keystroke. filterRows still narrows
    // the returned rows client-side for instant feedback.
    this.setState({ searchQuery: value, currentPage: 1 });
    clearTimeout(this._searchTimer);
    this._searchTimer = setTimeout(() => this.fetchData(), 400);
  };

  // Load the next batch and APPEND it to the current list.
  loadMorePatients = () => {
    if (this.state.loadingMore) return;
    this.setState({ loadingMore: true });
    this.fetchData({ append: true });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleNextPage = () => {
    const totalPages = Math.ceil(
      this.filterRows().length / this.state.rowsPerPage
    );
    this.setState((prevState) => ({
      currentPage: Math.min(prevState.currentPage + 1, totalPages),
    }));
  };
  handlePrevPage = () => {
    this.setState((prevState) => ({
      currentPage: Math.max(prevState.currentPage - 1, 1),
    }));
  };

  handleRowClick(event) {
    const target = event.target;
    console.log("clicked!!!!!!!!!!!");
    // Check if the click happened on the specific columns (2, 3, or 4)
    if (target.closest("td:nth-child(2), td:nth-child(3), td:nth-child(4)")) {
      const row = target.closest("tr");
      const urlElement = row.querySelector(".patientLink");
      const url = urlElement ? urlElement.value : ""; // Avoid optional chaining

      // Check if a URL exists and navigate to it
      if (url && url.trim() !== "") {
        window.location.href = url;
      }
    }
  }
  handleToggle = (type) => {
    this.setState({ selectedType: type });
  };
  clearShareReportState = () => {
    this.setState({
      customermailid: "",
      whatsappNumber: "",
      mailid: "",
      arrythymia: "",
      patientmailid: "",
      patientwhatsappNumber: "",
      patientmailsubject: "",
      patientwhatsappMessage: "",
    });
  };
  handleDoctorChange = (selectedOption) => {
    this.setState({ selectedDoctor: selectedOption });
    // console.log("Selected doctor:", selectedOption);
    // Perform any action needed with the selected doctor
  };
  handleDateChange = (inputDate) => {
    let formattedDate = inputDate;
    if (
      inputDate &&
      typeof inputDate === "object" &&
      inputDate._isAMomentObject
    ) {
      // If using moment.js object from Datetime
      formattedDate = inputDate.format("MM/DD/YYYY");
    } else if (inputDate instanceof Date && !isNaN(inputDate.getTime())) {
      // If using native Date object
      const mm = String(inputDate.getMonth() + 1).padStart(2, "0");
      const dd = String(inputDate.getDate()).padStart(2, "0");
      const yyyy = inputDate.getFullYear();
      formattedDate = `${mm}/${dd}/${yyyy}`;
    } else if (typeof inputDate === "string") {
      // If string, try to parse as date
      const dateObj = new Date(inputDate);
      if (!isNaN(dateObj.getTime())) {
        const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
        const dd = String(dateObj.getDate()).padStart(2, "0");
        const yyyy = dateObj.getFullYear();
        formattedDate = `${mm}/${dd}/${yyyy}`;
      } else {
        formattedDate = inputDate;
      }
    }
    this.setState({ dob: formattedDate });
  };
  render() {
    const { isConfirmationModalOpen, selectedConfirmation } = this.state;
    const { currentPage, rowsPerPage, dob } = this.state;

    const { columns, rows } = this.state;

    const totalPages = Math.ceil(this.filterRows().length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const displayedRows = this.filterRows().slice(
      startIndex,
      startIndex + rowsPerPage
    );

    // Pagination range logic (show up to 8 page numbers)
    const paginationNumbers = [];
    const startPage = Math.max(1, currentPage - 4);
    const endPage = Math.min(totalPages, startPage + 7);

    for (let i = startPage; i <= endPage; i++) {
      paginationNumbers.push(i);
    }
    const filteredRows = this.filterRows();
    if (localStorage.jwtToken == undefined) {
      window.location.href = "/";
    }
    const { errors, doctors, selectedDoctor } = this.state;
    const options = doctors.map((doctor) => ({
      value: doctor._id,
      label: doctor.name,
    }));

    let doctorsList =
      this.state.doctors.length > 0 &&
      this.state.doctors.map((item, i) => {
        return (
          <option
            key={i}
            value={item._id}
            selected={this.state.doctor_name == item.name}
          >
            {item.name}
          </option>
        );
      }, this);

    return (
      <div className="wrapper theme-6-active box-layout pimary-color-green">
        <Toaster position="top-right" reverseOrder={false} />

        {/* TopNav hidden on verifier-home — removes top bar entirely */}
        <AddModalComplete
          userid={this.state.userid}
          isOpen={this.state.isModalCompleteOpen}
          patientName={this.state.patientName}
        />

        <SideBar menus={this.state.menus} />
        <div className="right-sidebar-backdrop"></div>
        <div className="page-wrapper" style={{ marginTop: "10px" }}>
          <div className="container-fluid">
            <div id="myModalDHome" className="modal fade" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">
                      General Settings
                    </h4>
                  </div>
                  <form method="post" onSubmit={this.onSubmit}>
                    <div className="modal-body">
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Normal Heart Rate Min
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.nor_minhr,
                              })}
                              name="nor_minhr"
                              required=""
                              id="nor_minhr"
                              onChange={this.onChange}
                              value={this.state.nor_minhr}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Normal Heart Rate Max
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.nor_maxhr,
                              })}
                              name="nor_maxhr"
                              required=""
                              id="nor_maxhr"
                              onChange={this.onChange}
                              value={this.state.nor_maxhr}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Formula
                            </label>
                            <select
                              name="qtcformula"
                              className={classnames("form-control", {
                                errors: errors.qtcformula,
                              })}
                              value={this.state.qtcformula}
                              onChange={this.onChange}
                            >
                              <option value="Bazett">Bazett </option>
                              <option value="Fridericia">Fridericia</option>
                              <option value="Framingham">Framingham</option>
                              <option value="Hodges">Hodges</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Value Min
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qtcvalue_min,
                              })}
                              name="qtcvalue_min"
                              required=""
                              id="qtcvalue_min"
                              onChange={this.onChange}
                              value={this.state.qtcvalue_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Value Max
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qtcvaluemax,
                              })}
                              name="qtcvaluemax"
                              required=""
                              id="qtcvaluemax"
                              onChange={this.onChange}
                              value={this.state.qtcvaluemax}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Width Min(ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrswidth_min,
                              })}
                              name="qrswidth_min"
                              required=""
                              id="qrswidth_min"
                              onChange={this.onChange}
                              value={this.state.qrswidth_min}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Width Max (ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrswidth_max,
                              })}
                              name="qrswidth_max"
                              required=""
                              id="qrswidth_max"
                              onChange={this.onChange}
                              value={this.state.qrswidth_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrsamp_min,
                              })}
                              name="qrsamp_min"
                              required=""
                              id="qrsamp_min"
                              onChange={this.onChange}
                              value={this.state.qrsamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrsamp_max,
                              })}
                              name="qrsamp_max"
                              required=""
                              id="qrsamp_max"
                              onChange={this.onChange}
                              value={this.state.qrsamp_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              ST Elevation (mm)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.stelevation,
                              })}
                              name="stelevation"
                              required=""
                              id="stelevation"
                              onChange={this.onChange}
                              value={this.state.stelevation}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Width Min (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pwidth_min,
                              })}
                              name="pwidth_min"
                              required=""
                              id="pwidth_min"
                              onChange={this.onChange}
                              value={this.state.pwidth_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Width Max (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pwidth_max,
                              })}
                              name="pwidth_max"
                              required=""
                              id="pwidth_max"
                              onChange={this.onChange}
                              value={this.state.pwidth_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pamp_min,
                              })}
                              name="pamp_min"
                              required=""
                              id="pamp_min"
                              onChange={this.onChange}
                              value={this.state.pamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pamp_max,
                              })}
                              name="pamp_max"
                              required=""
                              id="pamp_max"
                              onChange={this.onChange}
                              value={this.state.pamp_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Width Min (ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.twidth_min,
                              })}
                              name="twidth_min"
                              required=""
                              id="twidth_min"
                              onChange={this.onChange}
                              value={this.state.twidth_min}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Width Max (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.twidth_max,
                              })}
                              name="twidth_max"
                              required=""
                              id="twidth_max"
                              onChange={this.onChange}
                              value={this.state.twidth_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tamp_min,
                              })}
                              name="tamp_min"
                              required=""
                              id="tamp_min"
                              onChange={this.onChange}
                              value={this.state.tamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tamp_max,
                              })}
                              name="tamp_max"
                              required=""
                              id="tamp_max"
                              onChange={this.onChange}
                              value={this.state.tamp_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              PR Interval Min{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.printerval_min,
                              })}
                              name="printerval_min"
                              required=""
                              id="printerval_min"
                              onChange={this.onChange}
                              value={this.state.printerval_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              PR Interval Max{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.printerval_max,
                              })}
                              name="printerval_max"
                              required=""
                              id="printerval_max"
                              onChange={this.onChange}
                              value={this.state.printerval_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Tachy Lower Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tachyhr_lower,
                              })}
                              name="tachyhr_lower"
                              required=""
                              id="tachyhr_lower"
                              onChange={this.onChange}
                              value={this.state.tachyhr_lower}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Tachy Upper Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tachyhr_upper,
                              })}
                              name="tachyhr_upper"
                              required=""
                              id="tachyhr_upper"
                              onChange={this.onChange}
                              value={this.state.tachyhr_upper}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Brady Lower Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.bradyhr_lower,
                              })}
                              name="bradyhr_lower"
                              required=""
                              id="bradyhr_lower"
                              onChange={this.onChange}
                              value={this.state.bradyhr_lower}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Brady Upper Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.bradyhr_upper,
                              })}
                              name="bradyhr_upper"
                              required=""
                              id="bradyhr_upper"
                              onChange={this.onChange}
                              value={this.state.bradyhr_upper}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              ST Depression (mm)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.stdepression,
                              })}
                              name="stdepression"
                              required=""
                              id="stdepression"
                              onChange={this.onChange}
                              value={this.state.stdepression}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Pause Length (s){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pauselength,
                              })}
                              name="pauselength"
                              required=""
                              id="pauselength"
                              onChange={this.onChange}
                              value={this.state.pauselength}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Graphs To Be Generated(no:){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.graph_gen,
                              })}
                              name="graph_gen"
                              required=""
                              id="graph_gen"
                              onChange={this.onChange}
                              value={this.state.graph_gen}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="submit"
                        className="btn btn-success"
                        style={{ color: "Black" }}
                        disabled={this.state.loadingEditModal} // Disable while loading
                      >
                        Submit
                      </button>
                      {
                        <button
                          id="closePopup"
                          type="button"
                          className="btn btn-default closePopup"
                          data-dismiss="modal"
                          style={{ color: "Black" }}
                        >
                          Close
                        </button>
                      }
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div id="commentinfomodal" className="modal fade" role="dialog" aria-hidden="true">
              <div className="modal-dialog" style={{ maxWidth: 860, margin: "20px auto", width: "94%" }}>
                <div className="modal-content" style={{ borderRadius: 10, overflow: "hidden", border: "none", boxShadow: "0 12px 40px rgba(0,0,0,0.4)" }}>

                  {/* Header */}
                  <div style={{ background: "#1e2d38", padding: "12px 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                      <div style={{ color: "#fff", fontWeight: 700, fontSize: "15px", display: "flex", alignItems: "center", gap: 6 }}>
                        💬 Comments{(this.state.comments || "").trim() ? ` (${(this.state.comments || "").trim().split("\n").filter(l => l.trim()).length})` : ""}
                      </div>
                      {this.state.patient_name && (
                        <div style={{ color: "#89c4e1", fontSize: "12px", marginTop: 2 }}>
                          {this.state.patient_name}
                        </div>
                      )}
                    </div>
                    <button type="button" data-dismiss="modal" className="closePopup"
                      style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", width: 28, height: 28, borderRadius: "50%", fontSize: "16px", lineHeight: 1, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      ×
                    </button>
                  </div>

                  {/* Comment History */}
                  {(() => {
                    const raw = (this.state.comments || "").trim();
                    const lines = (raw ? raw.split("\n").filter((l) => l.trim()) : []).reverse(); // newest first
                    return (
                      <div style={{ background: "#f5f7fa", borderBottom: "1px solid #e2e8f0", maxHeight: "calc(100vh - 360px)", minHeight: 120, overflowY: "auto", padding: lines.length ? "12px 16px" : "0" }}>
                        {lines.length === 0 ? (
                          <div style={{ padding: "18px 16px", textAlign: "center", color: "#aaa", fontSize: "13px" }}>No comments yet</div>
                        ) : (
                          lines.map((line, idx) => {
                            const byMatch = line.match(/^(.*?)\s*[—–-]+\s*BY\s+(.+?)(?:\s*\[(.+?)\])?$/i)
                                         || line.match(/^(.*?)\s*—\s*(.+?)(?:\s*\[(.+?)\])?$/);
                            const text   = byMatch ? byMatch[1].trim() : line;
                            const author = byMatch ? byMatch[2].trim() : "";
                            const time   = byMatch ? byMatch[3] || "" : "";
                            const initials = author ? author.split(" ").map(w => w[0]).join("").slice(0,2).toUpperCase() : "?";
                            const colors = ["#3498db","#9b59b6","#1abc9c","#e67e22","#e74c3c","#2ecc71"];
                            const avatarColor = colors[initials.charCodeAt(0) % colors.length];
                            return (
                              <div key={idx} style={{ display: "flex", gap: 10, marginBottom: idx < lines.length - 1 ? 12 : 0 }}>
                                <div style={{ width: 32, height: 32, borderRadius: "50%", background: avatarColor, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: 700, flexShrink: 0, marginTop: 2 }}>
                                  {initials}
                                </div>
                                <div style={{ flex: 1 }}>
                                  <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "0 8px 8px 8px", padding: "8px 12px", fontSize: "13px", color: "#2d3748", lineHeight: 1.5, whiteSpace: "pre-line", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                                    {text.replace(/^\[[A-Za-z]+\][^|]*\|\s*/, "")}
                                  </div>
                                  <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: 3, paddingLeft: 2 }}>
                                    <span style={{ fontWeight: 600, color: "#64748b" }}>{author || (/^\[[A-Za-z]+\][^|]*\|/.test(text) ? "System · " + text.split("|")[0].replace(/[\[\]]/g, "").trim() : "Unknown")}</span>
                                    {time && <span style={{ marginLeft: 6 }}>{time}</span>}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    );
                  })()}

                  {/* New Comment Input */}
                  <div style={{ background: "#fff", padding: "14px 16px 10px" }}>
                    <div style={{ fontSize: "11px", fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 8 }}>Add New Comment</div>
                    <textarea
                      value={this.state.newComment || ""}
                      onChange={(e) => this.setState({ newComment: e.target.value })}
                      placeholder="Type your observation, finding or note here…"
                      maxLength={300}
                      rows={3}
                      style={{ width: "100%", fontSize: "13px", color: "#2d3748", border: "1px solid #cbd5e0", borderRadius: 6, padding: "10px 12px", resize: "none", outline: "none", fontFamily: "inherit", lineHeight: 1.6 }}
                      onFocus={e => e.target.style.borderColor = "#4299e1"}
                      onBlur={e => e.target.style.borderColor = "#cbd5e0"}
                    />
                    <div style={{ textAlign: "right", fontSize: "11px", color: (this.state.newComment || "").length > 250 ? "#e74c3c" : "#94a3b8", marginTop: 3 }}>
                      {(this.state.newComment || "").length}/300
                    </div>
                  </div>

                  {/* Footer */}
                  <div style={{ padding: "8px 16px 14px", background: "#fff", display: "flex", justifyContent: "flex-end", gap: 8, borderTop: "1px solid #f0f0f0" }}>
                    <button type="button" data-dismiss="modal" className="closePopup"
                      style={{ padding: "7px 20px", fontSize: "13px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, color: "#555", cursor: "pointer", fontWeight: 500 }}>
                      Cancel
                    </button>
                    <button id={this.state.userid} type="button" onClick={this.submitComment}
                      disabled={!(this.state.newComment || "").trim()}
                      style={{ padding: "7px 22px", fontSize: "13px", background: (this.state.newComment || "").trim() ? "#1e8449" : "#a8d5b5", border: "none", borderRadius: 6, color: "#fff", fontWeight: 700, cursor: (this.state.newComment || "").trim() ? "pointer" : "not-allowed" }}>
                      ✓ Add Comment
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* Billing Confirmation Modal — admin verifier reviews
                patient + customer details before confirming. Uses the
                SAME /confirmBilling endpoint as ReportPatientsList so
                state stays in sync across both pages, and the billing
                is naturally linked to the customer via customerName. */}
            <div id="billingModalVH" className="modal fade" role="dialog" aria-hidden="true">
              <div className="modal-dialog" style={{ maxWidth: 480, margin: "60px auto", width: "90%" }}>
                <div className="modal-content" style={{ borderRadius: 12, overflow: "hidden", border: "none", boxShadow: "0 20px 60px rgba(0,0,0,0.5)", background: "#ffffff" }}>

                  <div style={{ background: "#f4f7f9", padding: "16px 22px", borderBottom: "1px solid #dde3e8", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                      <div style={{ color: "#0a8aa0", fontWeight: 700, fontSize: "15px" }}>Confirm Billing</div>
                      <div style={{ color: "#5b6770", fontSize: "12px", marginTop: 2 }}>
                        Review and confirm billing for this patient
                      </div>
                    </div>
                    <button type="button" data-dismiss="modal"
                      onClick={() => this.setState({ billingPatient: null })}
                      style={{ background: "rgba(10,138,160,0.10)", border: "1px solid #cdd7df", color: "#0a8aa0", width: 30, height: 30, borderRadius: "50%", fontSize: "16px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      ×
                    </button>
                  </div>

                  {(() => {
                    const bp     = this.state.billingPatient || {};
                    const fields = this.state.billingFields;
                    const labelS = { display: "block", color: "#5b6770", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 5 };
                    const inputS = { width: "100%", padding: "8px 10px", background: "#ffffff", border: "1px solid #cdd7df", borderRadius: 6, color: "#1f2933", fontSize: "13px", outline: "none", boxSizing: "border-box" };
                    // Customer dropdown options: EVERY registered customer
                    // (fetched from /getCustomerNames), unioned with any name
                    // already present on the loaded patients — so a customer is
                    // never missing just because none of their patients happen
                    // to be on screen, and nothing that used to list disappears.
                    const customerOpts = Array.from(new Set(
                      []
                        .concat(this.state.customerNames || [])
                        .concat((this.state.patients || []).map((p) => p.customerName))
                        .map((v) => String(v || "").trim())
                        .filter(Boolean)
                        .filter((v) => v.toUpperCase() !== "NA")
                    )).sort();
                    return (
                      <div style={{ padding: "18px 22px" }}>
                        {/* Read-only header row — Patient + Device ID for context */}
                        <div style={{ marginBottom: 14, padding: "10px 12px", background: "#f4f7f9", border: "1px solid #dde3e8", borderRadius: 8, display: "flex", justifyContent: "space-between", fontSize: "12px" }}>
                          <div>
                            <div style={{ color: "#5b6770" }}>Patient</div>
                            <div style={{ color: "#1f2933", fontWeight: 700 }}>{bp.name || "—"}</div>
                          </div>
                          <div style={{ textAlign: "right" }}>
                            <div style={{ color: "#5b6770" }}>Device ID</div>
                            <div style={{ color: "#1f2933", fontWeight: 700 }}>{bp.device_id || "—"}</div>
                          </div>
                        </div>

                        {/* Editable fields */}
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px" }}>
                          <div>
                            <label style={labelS}>Customer Name</label>
                            <select name="customerName" value={fields.customerName} onChange={this.handleBillingFieldChange} style={inputS}>
                              <option value="">Select Customer</option>
                              {customerOpts.map((name, idx) => (
                                <option key={idx} value={name}>{name}</option>
                              ))}
                              {/* Keep current value if not in patient list */}
                              {fields.customerName && !customerOpts.includes(fields.customerName) && (
                                <option value={fields.customerName}>{fields.customerName}</option>
                              )}
                            </select>
                          </div>
                          <div>
                            <label style={labelS}>IP / OP</label>
                            <input name="ip_op" value={fields.ip_op} onChange={this.handleBillingFieldChange} placeholder="e.g. PR1234 or OP" style={inputS} />
                          </div>
                          <div>
                            <label style={labelS}>Doctor Name</label>
                            {/* Dropdown of registered doctors fetched via
                                worker from /api/users/alldoctors at mount.
                                Falls back to a free-text option when the
                                currently registered name is not in the
                                doctor list (e.g. legacy or freeform entry). */}
                            <select
                              name="doctorname"
                              value={fields.doctorname || ""}
                              onChange={this.handleBillingFieldChange}
                              style={inputS}
                            >
                              <option value="">Select Doctor</option>
                              {(this.state.doctors || [])
                                .map((d) => d && d.name)
                                .filter(Boolean)
                                .sort()
                                .map((name, idx) => (
                                  <option key={idx} value={name}>{name}</option>
                                ))}
                              {/* Preserve the current value if it's not in
                                  the registered list — otherwise opening
                                  the modal would silently blank it out. */}
                              {fields.doctorname && !(this.state.doctors || []).some((d) => d && d.name === fields.doctorname) && (
                                <option value={fields.doctorname}>{fields.doctorname} (current)</option>
                              )}
                            </select>
                          </div>
                          <div>
                            <label style={labelS}>Duration</label>
                            <select name="duration" value={fields.duration} onChange={this.handleBillingFieldChange} style={inputS}>
                              <option value="">Select</option>
                              {Array.from({ length: 31 }, (_, i) => i + 1).map((d) => (
                                <option key={d} value={String(d * 24)}>{d} day{d > 1 ? "s" : ""}</option>
                              ))}
                            </select>
                          </div>
                          <div>
                            <label style={labelS}>Customer Email (for Report)</label>
                            <input name="mailReport" type="email" value={fields.mailReport} onChange={this.handleBillingFieldChange} placeholder="customer@clinic.com" style={inputS} />
                          </div>
                          <div>
                            <label style={labelS}>Customer WhatsApp</label>
                            <input name="whatsapp" type="tel" value={fields.whatsapp} onChange={this.handleBillingFieldChange} placeholder="+91XXXXXXXXXX" style={inputS} />
                          </div>
                        </div>

                        {/* Customer comments / customisation — stored once on
                            the customer record, shown for every patient of
                            this customer. Editable + saved from here. */}
                        <div style={{ marginTop: 14 }}>
                          <label style={labelS}>
                            Customer Comments (customisation)
                          </label>
                          <textarea
                            rows={3}
                            value={this.state.billingCustomerComments}
                            onChange={(e) =>
                              this.setState({ billingCustomerComments: e.target.value })
                            }
                            placeholder="e.g. report format preferences, delivery instructions, billing notes…"
                            style={{ ...inputS, resize: "vertical", fontFamily: "inherit" }}
                          />
                          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 6 }}>
                            <button
                              type="button"
                              onClick={this.saveCustomerComments}
                              disabled={this.state.billingCommentsSaving || !fields.customerName}
                              style={{
                                padding: "5px 14px",
                                fontSize: "12px",
                                background: this.state.billingCommentsSaving ? "#cdd7df" : "#eef2f5",
                                border: "1px solid #0a8aa0",
                                borderRadius: 6,
                                color: "#0a8aa0",
                                cursor: this.state.billingCommentsSaving || !fields.customerName ? "not-allowed" : "pointer",
                                fontWeight: 600,
                              }}
                            >
                              {this.state.billingCommentsSaving ? "Saving…" : "Save comments"}
                            </button>
                          </div>
                        </div>

                        {/* Delivery status — read only */}
                        <div style={{ marginTop: 14, padding: "10px 12px", background: "#f4f7f9", border: "1px solid #dde3e8", borderRadius: 8, fontSize: "12px", color: "#5b6770" }}>
                          <div style={{ marginBottom: 4 }}>
                            <strong style={{ color: "#1f2933" }}>Email:</strong> {bp.mailsentime ? `sent ${bp.mailsentime}` : "not sent"}
                          </div>
                          <div>
                            <strong style={{ color: "#1f2933" }}>WhatsApp:</strong> {bp.whatsappsenttime ? `sent ${bp.whatsappsenttime}` : "not sent"}
                          </div>
                        </div>
                      </div>
                    );
                  })()}

                  <div style={{ padding: "14px 22px", borderTop: "1px solid #dde3e8", display: "flex", justifyContent: "flex-end", gap: 10, background: "#f4f7f9" }}>
                    <button type="button" data-dismiss="modal"
                      onClick={() => this.setState({ billingPatient: null })}
                      style={{ padding: "8px 20px", fontSize: "13px", background: "transparent", border: "1px solid #cdd7df", borderRadius: 7, color: "#5b6770", cursor: "pointer", fontWeight: 500 }}>
                      Cancel
                    </button>
                    <button type="button" data-dismiss="modal"
                      onClick={this.markBilling}
                      disabled={this.state.markingBilling}
                      style={{ padding: "8px 24px", fontSize: "13px", background: this.state.markingBilling ? "#cdd7df" : "#0a8aa0", border: "none", borderRadius: 7, color: "#ffffff", fontWeight: 700, cursor: this.state.markingBilling ? "not-allowed" : "pointer" }}>
                      {this.state.markingBilling ? "Confirming…" : "Confirm Billing"}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="mailinfomodal"
              className="modal fade"
              role="dialog"
              aria-labelledby="mailinfomodal"
              aria-hidden="true"
              onClick={(e) => {
                if (
                  e.target.className.includes("close") ||
                  e.target.className.includes("btn-default")
                ) {
                  this.clearShareReportState();
                }
              }}
            >
              <div
                className="modal-dialog"
                style={{ maxWidth: "560px" }}
              >
                <div
                  className="modal-content"
                  style={{
                    background: "#072224",                   // matches patient-list / AttendanceView panel bg
                    border: "1px solid #1e6b72",             // dark-teal border (sidebar accent)
                    borderRadius: 14,
                    boxShadow: "0 24px 48px rgba(0,0,0,0.45)",
                    color: "#e6e6e6",
                    overflow: "hidden",
                    fontFamily:
                      '"Inter","Segoe UI",system-ui,-apple-system,sans-serif',
                  }}
                >
                  {/* Header — same dark-teal gradient as the dashboard's
                      "Verifier Home" / patient-list panel heads */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "16px 20px",
                      background:
                        "linear-gradient(135deg,#0c2e32 0%,#1e6b72 100%)",
                      borderBottom: "2px solid #1e6b72",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        fontSize: 15,
                        fontWeight: 700,
                        letterSpacing: 0.4,
                        color: "#ffffff",
                      }}
                    >
                      <span aria-hidden="true" style={{ fontSize: 20 }}>📤</span>
                      Share Report
                      {this.state.patientNameForShare && (
                        <span style={{ fontSize: 12, fontWeight: 500, opacity: 0.85, marginLeft: 8 }}>
                          — {this.state.patientNameForShare}
                        </span>
                      )}
                    </div>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={this.clearShareReportState}
                      style={{
                        background: "rgba(255,255,255,0.12)",
                        border: "none",
                        color: "#fff",
                        width: 30,
                        height: 30,
                        borderRadius: 999,
                        fontSize: 16,
                        cursor: "pointer",
                        opacity: 1,
                        lineHeight: 1,
                      }}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div style={{ padding: "18px 22px" }}>
                    {/* Pill toggle: Customer / Patient */}
                    <div
                      style={{
                        display: "inline-flex",
                        background: "#0c1018",
                        border: "1px solid #2a2f3a",
                        borderRadius: 999,
                        padding: 3,
                        marginBottom: 16,
                      }}
                    >
                      {["customer", "patient"].map((opt) => {
                        const active = this.state.selectedType === opt;
                        return (
                          <button
                            key={opt}
                            type="button"
                            onClick={() =>
                              this.setState({ selectedType: opt })
                            }
                            style={{
                              background: active
                                ? "linear-gradient(135deg,#2eaabb,#1a6a72)"   // teal — matches sidebar active accent
                                : "transparent",
                              color: active ? "#fff" : "#8a93a0",
                              border: "none",
                              padding: "7px 22px",
                              borderRadius: 999,
                              fontSize: 12,
                              fontWeight: 700,
                              letterSpacing: 0.5,
                              textTransform: "uppercase",
                              cursor: "pointer",
                              transition: "background 0.15s ease, color 0.15s ease",
                            }}
                          >
                            {opt === "customer" ? "🏥 Customer" : "👤 Patient"}
                          </button>
                        );
                      })}
                    </div>

                    {/* Patient-only header: registration number + name —
                        teal-tinted to match the rest of the dashboard's
                        accent. Replaces the previous blue-tinted card. */}
                    {this.state.selectedType === "patient" && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 10,
                          padding: "10px 14px",
                          background: "rgba(46,170,187,0.10)",
                          border: "1px solid rgba(46,170,187,0.35)",
                          borderRadius: 8,
                          marginBottom: 14,
                          fontSize: 12,
                        }}
                      >
                        <div>
                          <div style={{ color: "#8a93a0", fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>
                            Registration No.
                          </div>
                          <div style={{ color: "#8ecfda", fontSize: 16, fontWeight: 700, fontFamily: 'Menlo, Consolas, monospace', marginTop: 2 }}>
                            {this.state.patientRegNumber || "—"}
                          </div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <div style={{ color: "#8a93a0", fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>
                            Patient
                          </div>
                          <div style={{ color: "#e6e6e6", fontSize: 13, fontWeight: 600, marginTop: 2 }}>
                            {this.state.patientNameForShare || "—"}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Mail section */}
                    <SectionLabel icon="✉️" text={`Mail Report (${this.state.selectedType === "customer" ? "Customer" : "Patient"})`} />
                    <input
                      value={
                        this.state.selectedType === "customer"
                          ? this.state.customermailid
                          : this.state.patientmailid
                      }
                      placeholder="Enter email(s) separated by commas…"
                      onChange={(e) =>
                        this.setState(
                          this.state.selectedType === "customer"
                            ? { customermailid: e.target.value }
                            : { patientmailid: e.target.value }
                        )
                      }
                      style={modernInputStyle}
                    />
                    <textarea
                      value={
                        this.state.selectedType === "customer"
                          ? this.state.mailsubject
                          : this.state.patientmailsubject
                      }
                      placeholder="Enter email subject…"
                      onChange={(e) =>
                        this.setState(
                          this.state.selectedType === "customer"
                            ? { mailsubject: e.target.value }
                            : { patientmailsubject: e.target.value }
                        )
                      }
                      style={{ ...modernInputStyle, minHeight: 64, resize: "vertical", fontFamily: "inherit" }}
                    />

                    {/* WhatsApp section */}
                    <div style={{ marginTop: 14 }} />
                    <SectionLabel icon="📱" text={`WhatsApp Report (${this.state.selectedType === "customer" ? "Customer" : "Patient"})`} />
                    <input
                      value={
                        this.state.selectedType === "customer"
                          ? this.state.whatsappNumber
                          : this.state.patientwhatsappNumber
                      }
                      placeholder="Enter 10-digit WhatsApp number(s) separated by commas…"
                      onChange={(e) =>
                        this.setState(
                          this.state.selectedType === "customer"
                            ? { whatsappNumber: e.target.value }
                            : { patientwhatsappNumber: e.target.value }
                        )
                      }
                      style={modernInputStyle}
                    />
                    <textarea
                      value={this.state.arrythymia}
                      placeholder="Enter WhatsApp message…"
                      onChange={(e) =>
                        this.setState({ arrythymia: e.target.value })
                      }
                      style={{ ...modernInputStyle, minHeight: 64, resize: "vertical", fontFamily: "inherit" }}
                    />

                    {/* Schedule */}
                    <div style={{ marginTop: 14 }} />
                    <SectionLabel icon="🕐" text="Schedule (optional)" />
                    <input
                      type="datetime-local"
                      value={this.state.setCompletionDate}
                      onChange={(e) =>
                        this.setState({ setCompletionDate: e.target.value })
                      }
                      onClick={() =>
                        this.setState({
                          setCompletionDate: this.getCurrentDateTime(),
                        })
                      }
                      style={modernInputStyle}
                    />
                  </div>

                  {/* Footer — uses the same deep-teal background as the
                      dashboard's panel footers for visual consistency */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 8,
                      padding: "12px 22px 18px",
                      borderTop: "1px solid #0c2e30",
                      background: "#041415",
                    }}
                  >
                    <button
                      type="button"
                      className="btn-default closePopup"
                      data-dismiss="modal"
                      onClick={this.clearShareReportState}
                      style={{
                        background: "transparent",
                        color: "#89a8c0",
                        border: "1px solid #1e6b72",
                        padding: "8px 18px",
                        borderRadius: 8,
                        fontSize: 13,
                        fontWeight: 600,
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      data-dismiss="modal"
                      onClick={() => {
                        if (this.state.selectedType === "customer") {
                          this.sentMailReport();
                          this.sentWhatsappReport();
                        } else {
                          this.sentMailReportPatient();
                          this.sentWhatsappReportPatient();
                        }
                        this.clearShareReportState();
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        background:
                          "linear-gradient(135deg,#2ECD99 0%,#25a87c 100%)",   // mint green — matches Full Disclosure
                        color: "#fff",
                        border: "none",
                        padding: "8px 22px",
                        borderRadius: 8,
                        fontSize: 13,
                        fontWeight: 700,
                        cursor: "pointer",
                        boxShadow: "0 2px 8px rgba(46,205,153,0.4)",
                      }}
                    >
                      <span aria-hidden="true">📤</span> Send
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="whatsappinfomodal"
              className="modal fade"
              role="dialog"
              aria-labelledby="whatsappinfomodal"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4
                      className="modal-title text-center"
                      id="whatsappinfomodal"
                    >
                      Share Report Via Whatsapp
                    </h4>
                  </div>

                  <div className="modal-body">
                    <input
                      value={this.state.whatsappNumber || ""}
                      //Default to empty string if comments is undefined.
                      style={{ width: "100%", color: "black" }}
                      placeholder="Enter whatsapp to share report....."
                      onChange={(e) =>
                        this.setState({ whatsappNumber: e.target.value })
                      }
                      // Update comments directly in state.
                    />
                    <textarea
                      onChange={(e) => {
                        const value = e.target.value;
                        // Get the current value.
                        console.log("Typing value:", value);
                        // Log the value to the console.
                        this.setState({ arrythymia: value });
                        // Update state.
                      }}
                      // value={this.state.mailsubject} // Bind to the dynamic state.
                      placeholder="Enter Report Subject Here..."
                      className="subject-textarea"
                    />
                  </div>
                  <div className="modal-footer">
                    <div className="row row-sm-offset">
                      <div className="col-md-6 multi-horizontal">
                        <button
                          id={this.state.userid}
                          type="submit"
                          className="btn btn-success"
                          style={{ color: "Black" }}
                          onClick={this.sentWhatsappReport}
                        >
                          Submit
                        </button>
                      </div>
                      <div className="col-md-6 multi-horizontal text-left">
                        <button
                          type="button"
                          className="btn btn-default closePopup"
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="editInfoModal"
              className="modal fade"
              role="dialog"
              data-backdrop="static"
              data-keyboard="false"
            >
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header" style={{ background: "#24333e", padding: "10px 16px", borderRadius: "6px 6px 0 0" }}>
                    <button type="button" className="close" data-dismiss="modal" onClick={this.resetInfoModal.bind(this)} style={{ color: "#fff", opacity: 0.8, marginTop: 0 }}>
                      &times;
                    </button>
                    <h4 className="modal-title" style={{ color: "#fff", fontSize: "15px", fontWeight: 600 }}>
                      ✏️ Edit Patient
                      {this.state.patient_name ? <span style={{ fontWeight: 400, fontSize: "13px", marginLeft: 8, opacity: 0.75 }}>— {this.state.patient_name}</span> : ""}
                    </h4>
                  </div>

                  <form method="post" onSubmit={this.onSubmitInfo}>
                    <div className="modal-body" style={{ position: "relative", padding: "16px 20px", fontSize: "13px" }}>
                      {/* Loading overlay */}
                      {this.state.loadingEditModal && (
                        <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(255,255,255,0.8)", zIndex: 10, display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <div style={{ width: 40, height: 40, border: "5px solid #f3f3f3", borderTop: "5px solid #3498db", borderRadius: "50%", animation: "spin 0.8s linear infinite" }}></div>
                          <style>{`@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}`}</style>
                        </div>
                      )}


                      {/* ── SECTION: Patient Info ── */}
                      <div style={{ background: "#f8f9fa", borderRadius: "6px", padding: "10px 14px", marginBottom: "10px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Patient Info</div>
                        <div className="row" style={{ marginBottom: 0 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Name</label>
                              <input type="text" className="form-control input-sm" name="patient_name" onChange={this.onChange} value={this.state.patient_name} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Email</label>
                              <input type="text" className="form-control input-sm" name="email_id" onChange={this.onChange} value={this.state.email_id} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Phone</label>
                              <input type="text" className="form-control input-sm" name="phone" onChange={this.onChange} value={this.state.phone} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginBottom: 0 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Hospital</label>
                              <input type="text" className="form-control input-sm" name="hospital" onChange={this.onChange} value={this.state.hospital} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Doctor</label>
                              <Select
                                options={options}
                                value={selectedDoctor}
                                onChange={this.handleDoctorChange}
                                placeholder="Search Doctor"
                                classNamePrefix="react-select"
                                styles={{
                                  control: (base) => ({ ...base, minHeight: 30, height: 30, fontSize: "13px", borderColor: errors.doctor_id ? "red" : base.borderColor }),
                                  valueContainer: (base) => ({ ...base, padding: "0 6px" }),
                                  indicatorsContainer: (base) => ({ ...base, height: 30 }),
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>IP/OP</label>
                              <input type="text" className="form-control input-sm" onChange={this.onIpOpChange} value={this.state.ipop} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>DOB</label>
                              <Datetime
                                value={dob}
                                onChange={this.handleDateChange}
                                inputProps={{ className: "form-control input-sm", placeholder: "Date", style: { height: 30, fontSize: "12px" } }}
                                dateFormat="MM/DD/YYYY"
                                timeFormat={false}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginBottom: 0 }}>
                          <div className="col-md-8" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Customer</label>
                              <Select
                                options={
                                  this.state.editCustomer &&
                                  !(this.state.customerOptions || []).some((o) => o.value === this.state.editCustomer.value)
                                    ? [this.state.editCustomer].concat(this.state.customerOptions || [])
                                    : this.state.customerOptions || []
                                }
                                value={this.state.editCustomer}
                                onChange={(opt) => this.setState({ editCustomer: opt })}
                                placeholder="Search Customer"
                                noOptionsMessage={() => "No customers found"}
                                classNamePrefix="react-select"
                                styles={{
                                  control: (base) => ({ ...base, minHeight: 30, height: 30, fontSize: "13px" }),
                                  valueContainer: (base) => ({ ...base, padding: "0 6px" }),
                                  indicatorsContainer: (base) => ({ ...base, height: 30 }),
                                  menu: (base) => ({ ...base, zIndex: 20, fontSize: "13px", background: "#fff" }),
                                  // Explicit colours: the app's dark theme otherwise
                                  // renders the options as light grey on white.
                                  option: (base, state) => ({
                                    ...base,
                                    color: state.isSelected ? "#fff" : "#222",
                                    background: state.isSelected ? "#2e86de" : state.isFocused ? "#e8f1fb" : "#fff",
                                    opacity: 1,
                                    cursor: "pointer",
                                  }),
                                  singleValue: (base) => ({ ...base, color: "#222" }),
                                  input: (base) => ({ ...base, color: "#222" }),
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ── SECTION: Clinical Settings ── */}
                      <div style={{ background: "#f8f9fa", borderRadius: "6px", padding: "10px 14px", marginBottom: "10px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Clinical Settings</div>
                        <div className="row" style={{ marginBottom: 6 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>File Type</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["easy","moderate","hard"].map((ft, i, arr) => (
                                <button key={ft} type="button"
                                  onClick={() => this.handleTypeChange({ target: { value: ft } })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.filetype === ft ? "#24333e" : "#fff", color: this.state.filetype === ft ? "#fff" : "#333", cursor: "pointer", textTransform: "capitalize", borderRadius: i === 0 ? "4px 0 0 4px" : i === arr.length-1 ? "0 4px 4px 0" : "0" }}
                                >{ft.charAt(0).toUpperCase() + ft.slice(1)}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Priority <span style={{ fontWeight: 400, color: "#999" }}>(1=High)</span></label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {[{v:"1",label:"1–High",color:"#e74c3c"},{v:"2",label:"2–Med",color:"#f39c12"},{v:"3",label:"3–Normal",color:"#27ae60"}].map((p, i, arr) => (
                                <button key={p.v} type="button"
                                  onClick={() => this.onPriorityChange({ target: { value: p.v } })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "11px", fontWeight: 600, border: "1px solid #ccc", background: String(this.state.priority) === p.v ? p.color : "#fff", color: String(this.state.priority) === p.v ? "#fff" : "#555", cursor: "pointer", borderRadius: i === 0 ? "4px 0 0 4px" : i === arr.length-1 ? "0 4px 4px 0" : "0" }}
                                >{p.label}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Report Status</label>
                            <select className="form-control input-sm" value={this.state.reportstatus} onChange={this.onReportStatuschange} style={{ height: 30, fontSize: "12px", padding: "2px 6px" }}>
                              <option value="0">Not Analyzed</option>
                              <option value="6">Analyze Completed</option>
                              <option value="3">Verification Completed</option>
                              <option value="4">In Preparation</option>
                              <option value="5">Report Completed</option>
                            </select>
                          </div>
                        </div>
                        <div className="row" style={{ marginBottom: 6 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 6 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Indication</label>
                              <input type="text" className="form-control input-sm" name="indication" onChange={this.onChange} value={this.state.indication} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 6 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Monitoring Duration (Days)</label>
                              <input type="text" className="form-control input-sm" onChange={this.onDurationChange} value={this.state.duration} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Confirmation</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {[{v:"Yes",color:"#27ae60"},{v:"No",color:"#e74c3c"},{v:"Hold",color:"#f39c12"},...(livePatientsEnabled ? [{v:"Live",color:"#8e44ad"}] : [])].map((item, i, arr) => (
                                <button key={item.v} type="button"
                                  onClick={() => {
                                    this.setState({ Confirmation: item.v, selectedConfirmation: item.v });
                                    axios.post(`${apiUrl}api/patients/updateConfirmation`, { userid: this.state.userid, Confirmation: item.v }).catch(err => console.error(err));
                                  }}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", fontWeight: 600, border: "1px solid #ccc", background: this.state.Confirmation === item.v ? item.color : "#fff", color: this.state.Confirmation === item.v ? "#fff" : "#555", cursor: "pointer", borderRadius: i === 0 ? "4px 0 0 4px" : i === arr.length-1 ? "0 4px 4px 0" : "0" }}
                                >{item.v}</button>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginBottom: 0 }}>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Gender</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["M","F"].map(g => (
                                <button key={g} type="button" onClick={() => this.onGenderChange({ target: { value: g } })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "13px", fontWeight: 600, border: "1px solid #ccc", background: this.state.gender === g ? "#24333e" : "#fff", color: this.state.gender === g ? "#fff" : "#333", cursor: "pointer", borderRadius: g === "M" ? "4px 0 0 4px" : "0 4px 4px 0" }}
                                >{g}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Atrial Fib</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["yes","no"].map(v => (
                                <button key={v} type="button" onClick={() => this.setState({ af: v })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.af === v ? (v==="yes"?"#e74c3c":"#27ae60") : "#fff", color: this.state.af === v ? "#fff" : "#333", cursor: "pointer", borderRadius: v==="yes"?"4px 0 0 4px":"0 4px 4px 0", textTransform: "capitalize" }}
                                >{v.charAt(0).toUpperCase()+v.slice(1)}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Cardiac Surg.</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["yes","no"].map(v => (
                                <button key={v} type="button" onClick={() => this.setState({ cardiac_surgery: v })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.cardiac_surgery === v ? (v==="yes"?"#e74c3c":"#27ae60") : "#fff", color: this.state.cardiac_surgery === v ? "#fff" : "#333", cursor: "pointer", borderRadius: v==="yes"?"4px 0 0 4px":"0 4px 4px 0", textTransform: "capitalize" }}
                                >{v.charAt(0).toUpperCase()+v.slice(1)}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Pacemaker</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {[true,false].map(v => (
                                <button key={String(v)} type="button" onClick={() => this.setState({ pacemaker: v })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.pacemaker === v ? (v?"#e74c3c":"#27ae60") : "#fff", color: this.state.pacemaker === v ? "#fff" : "#333", cursor: "pointer", borderRadius: v?"4px 0 0 4px":"0 4px 4px 0" }}
                                >{v?"Yes":"No"}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Prioritize Data</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["Yes","No"].map(v => (
                                <button key={v} type="button" onClick={() => this.setState({ prioritizeData: v })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.prioritizeData === v ? (v==="Yes"?"#3498db":"#95a5a6") : "#fff", color: this.state.prioritizeData === v ? "#fff" : "#333", cursor: "pointer", borderRadius: v==="Yes"?"4px 0 0 4px":"0 4px 4px 0" }}
                                >{v}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-2">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Issue Noticed</label>
                            <select className="form-control input-sm" value={this.state.issueReport} onChange={(e) => this.setState({ issueReport: e.target.value })} style={{ height: 30, fontSize: "12px", padding: "2px 6px" }}>
                              <option value="NA">None</option>
                              <option value="repeat">Repeat</option>
                              <option value="low_data">Low Data</option>
                              <option value="customer_reject">Customer Reject</option>
                              <option value="battery_issue">Battery Issue</option>
                              <option value="device_issue">Device Issue</option>
                            </select>
                          </div>
                        </div>
                        <div className="row" style={{ marginTop: 8 }}>
                          <div className="col-md-12">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Mark Label</label>
                            <Select
                              isMulti
                              options={[
                                { value: "NSR", label: "NSR" },{ value: "ST", label: "ST" },{ value: "SB", label: "SB" },
                                { value: "PAC", label: "PAC" },{ value: "PVC", label: "PVC" },{ value: "VT", label: "VT" },
                                { value: "AF", label: "AF" },{ value: "SP", label: "SP" },{ value: "3AVB", label: "3AVB" },
                                { value: "CHB", label: "CHB" },{ value: "2AVB", label: "2AVB" },{ value: "SVT", label: "SVT" },
                                { value: "JB", label: "JB" },{ value: "UN", label: "UN" },{ value: "PACED", label: "PACED" },
                              ]}
                              value={this.state.selectedLabels}
                              onChange={(selectedOptions) => this.setState({ selectedLabels: selectedOptions })}
                              placeholder="Select labels..."
                              className="basic-multi-select"
                              classNamePrefix="select"
                              styles={{
                                control: (base) => ({ ...base, fontSize: "12px", minHeight: 28 }),
                                option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#24333e" : state.isFocused ? "#e5e5e5" : null, color: state.isSelected ? "white" : "black", fontSize: "12px", padding: "4px 10px" }),
                                multiValue: (provided) => ({ ...provided, backgroundColor: "#24333e" }),
                                multiValueLabel: (provided) => ({ ...provided, color: "white", fontSize: "11px" }),
                                multiValueRemove: (provided) => ({ ...provided, color: "white" }),
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* ── SECTION: Support & Assignment ── */}
                      <div style={{ background: "#f8f9fa", borderRadius: "6px", padding: "10px 14px", marginBottom: "10px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Support & Assignment</div>
                        <div className="row" style={{ marginBottom: 6 }}>
                          <div className="col-md-3" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Support Person</label>
                              <select className="form-control input-sm" value={this.state.supportPerson} onChange={(e) => this.setState({ supportPerson: e.target.value })} style={{ height: 30, fontSize: "12px", padding: "2px 6px" }}>
                                <option value="">Select Person</option>
                                {this.state.supportPersons && this.state.supportPersons.length > 0 ? (
                                  this.state.supportPersons.map((person) => (
                                    <option key={person._id} value={person._id}>{person.name}</option>
                                  ))
                                ) : (
                                  <option disabled>Loading...</option>
                                )}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Support Level</label>
                              <select className="form-control input-sm" value={this.state.supportLevel} onChange={(e) => this.setState({ supportLevel: e.target.value })} style={{ height: 30, fontSize: "12px", padding: "2px 6px" }}>
                                <option value="">Level</option>
                                <option value="L0">L0</option>
                                <option value="L1">L1</option>
                                <option value="L2">L2</option>
                                <option value="L3">L3</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Support Notes</label>
                              <textarea className="form-control" rows="2" value={this.state.supportedMatter} onChange={(e) => this.setState({ supportedMatter: e.target.value })} placeholder="Enter support notes..." style={{ fontSize: "13px", resize: "none" }} />
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginBottom: 6 }}>
                          <div className="col-md-12">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 2, display: "block" }}>Assign Verifier</label>
                            <Select
                              isMulti
                              options={this.state.verifiers}
                              value={this.state.selectedVerifiers}
                              onChange={this.handleVerifierChange}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              placeholder="Select verifiers..."
                              menuPlacement="auto"
                              maxMenuHeight={140}
                              styles={{
                                control: (base) => ({ ...base, fontSize: "12px", minHeight: 28, maxHeight: 60, overflowY: "auto" }),
                                valueContainer: (base) => ({ ...base, padding: "2px 6px", flexWrap: "wrap", maxHeight: 54, overflowY: "auto" }),
                                indicatorsContainer: (base) => ({ ...base, height: 28, alignSelf: "flex-start" }),
                                option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#24333e" : state.isFocused ? "#e5e5e5" : null, color: state.isSelected ? "white" : "black", fontSize: "12px", padding: "4px 10px" }),
                                multiValue: (provided) => ({ ...provided, backgroundColor: "#24333e", margin: "1px 2px" }),
                                multiValueLabel: (provided) => ({ ...provided, color: "white", fontSize: "11px", padding: "1px 4px" }),
                                multiValueRemove: (provided) => ({ ...provided, color: "white", padding: "0 3px" }),
                              }}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Clinical Condition</label>
                              <textarea className="form-control" rows="2" value={this.state.clinicalCondition} onChange={(e) => this.setState({ clinicalCondition: e.target.value })} placeholder="Enter clinical condition..." style={{ fontSize: "13px", resize: "none" }} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer" style={{ padding: "10px 16px", display: "flex", justifyContent: "flex-end", gap: 8 }}>
                      <button type="button" className="btn closePopup" data-dismiss="modal" style={{ padding: "6px 20px", fontSize: "13px", background: "#f0f0f0", border: "1px solid #ccc", borderRadius: 4, color: "#444" }}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-success" disabled={this.state.loadingEditModal} style={{ padding: "6px 24px", fontSize: "13px", background: "#27ae60", border: "none", borderRadius: 4, color: "#fff", fontWeight: 600 }}>
                        {this.state.loadingEditModal ? "Saving…" : "✓ Save Changes"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div id="ConfirmInfoModal" className="modal fade" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">
                      Confirmation Status
                    </h4>
                  </div>
                  <div className="modal-body">
                    <div className="form-group">
                      <label
                        className="form-control-label mbr-fonts-style display-7"
                        style={{ color: "Black" }}
                      >
                        Select Status
                      </label>
                      <select
                        className="form-control"
                        value={this.state.selectedConfirmation}
                        onChange={this.handleConfirmationChange}
                      >
                        <option value="">Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="Hold">Hold</option>
                        {livePatientsEnabled && <option value="Live">Live</option>}
                      </select>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-success"
                      data-dismiss="modal"
                      onClick={this.handleConfirmationSubmit}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-default"
                      data-dismiss="modal"
                      onClick={this.handleConfirmationCancel}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div id="remarksModal" className="modal fade" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">📝 Support Notes</h4>
                  </div>
                  <div className="modal-body">
                    <div className="form-group">
                      <label
                        className="form-control-label mbr-fonts-style display-7"
                        style={{ color: "Black" }}
                      >
                        Support Notes
                      </label>
                      <textarea
                        className="form-control"
                        rows="4"
                        placeholder="Enter support notes here..."
                        value={this.state.remarksText}
                        onChange={(e) =>
                          this.setState({ remarksText: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-success"
                      data-dismiss="modal"
                      onClick={this.submitIssueReported.bind(this)}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-default"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="panel panel-default card-view">
                  <div
                    className="panel-heading"
                    style={{
                      display: "flex", alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 14px",
                      background: "#0c2e32",
                      borderBottom: "2px solid #1e6b72",
                    }}
                  >
                    <span style={{ color: "#ffffff", fontWeight: 700, fontSize: "14px" }}>
                      🏥 Verifier Home
                      {this.state.rows && this.state.rows.length > 0 && (
                        <span style={{ marginLeft: 8, fontSize: "11px", color: "#ffffff", background: "#1a6a72", borderRadius: 10, padding: "2px 10px", border: "1px solid #2a9aaa" }}>
                          {this.state.rows.length} patients
                        </span>
                      )}
                    </span>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <label style={{ marginBottom: 0, color: "#8ecfda", fontSize: "12px", fontWeight: 600 }}>
                        Load:
                      </label>
                      <select
                        value={this.state.batchSize || 50}
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          // Keep frontend pagination size in sync with the
                          // backend fetch size — so e.g. picking "200" loads
                          // 200 patients AND shows them all on one page.
                          // "All" (-1) maps to a very large page size so
                          // every loaded row renders without pagination.
                          const pageSize =
                            value === -1 ? Number.MAX_SAFE_INTEGER : value;
                          this.setState(
                            {
                              batchSize: value,
                              rowsPerPage: pageSize,
                              currentPage: 1,
                            },
                            () => {
                              this.fetchData();
                            }
                          );
                        }}
                        style={{ height: 34, fontSize: "12px", padding: "0 10px", borderRadius: 6, border: "2px solid #2eaabb", background: "#0f4a52", color: "#ffffff", outline: "none", cursor: "pointer", fontWeight: 600 }}
                      >
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                        <option value={-1}>All</option>
                      </select>
                      <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                        <span style={{ position: "absolute", left: 9, color: "#2eaabb", fontSize: "14px", pointerEvents: "none" }}>🔍</span>
                        <input
                          type="text"
                          placeholder="Search patient, doctor…"
                          style={{ height: 34, paddingLeft: 30, paddingRight: 10, fontSize: "12px", borderRadius: 6, border: "2px solid #2eaabb", background: "#0f4a52", color: "#ffffff", outline: "none", width: 210, fontWeight: 500 }}
                          value={this.state.searchQuery}
                          onChange={this.handleSearchChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="panel-wrapper collapse in">
                    <div className="panel-body" style={{ padding: 0 }}>
                      <table className="table table-striped" style={{ width: "100%", tableLayout: "fixed", marginBottom: 0 }}>
                        <colgroup>
                          <col style={{ width: "5%", minWidth: "50px" }} />
                          <col style={{ width: "18%", minWidth: "140px" }} />
                          <col style={{ width: "8%" }} />
                          <col style={{ width: "10%" }} />
                          <col style={{ width: "32%" }} />
                          <col style={{ width: "27%" }} />
                        </colgroup>
                        <thead>
                          <tr style={{ background: "#031213" }}>
                            {["SL","PATIENT","CREATED DATE","DISTRIBUTOR","ACTION","REPORT"].map((label) => (
                              <th key={label} style={{ padding: "7px 8px", textAlign: "center", color: "#89a8c0", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none", whiteSpace: "nowrap" }}>
                                {label}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {displayedRows.map((row, rowIndex) => (
                            <tr key={rowIndex} style={{ backgroundColor: row.backgroundColor }}>
                              <td style={{ textAlign: "center", verticalAlign: "middle", fontSize: "12px", whiteSpace: "nowrap" }}>
                                {startIndex + rowIndex + 1}
                              </td>
                              <td onClick={this.handleRowClick} style={{ cursor: "pointer", verticalAlign: "middle" }}>
                                <div style={{ fontWeight: 700, fontSize: "13px", lineHeight: 1.3, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{row.patientId}</div>
                                <div style={{ fontSize: "13px", fontWeight: 500, opacity: 0.9, marginTop: "3px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{row.name}</div>
                                {row.confirmation === "Live" && <LiveTag />}
                              </td>
                              <td style={{ verticalAlign: "middle", fontSize: "11px", whiteSpace: "nowrap" }}>{row.added_date}</td>
                              <td style={{ verticalAlign: "middle", fontSize: "11px" }}>{row.DistributorName || "NA"}</td>
                              <td className="Action-td" style={{ verticalAlign: "middle", textAlign: "center" }}>{row.action}</td>
                              <td style={{ verticalAlign: "middle" }}>{row.report}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {/* Pagination Controls — hidden when everything fits
                          on a single page (default flow: top "Load:" dropdown
                          syncs page size to fetch size). */}
                      <div
                        className="pagination-container"
                        style={{
                          display: totalPages > 1 ? "flex" : "none",
                          justifyContent: "flex-end",
                          marginTop: "10px",
                        }}
                      >
                        <button
                          onClick={this.handlePrevPage}
                          disabled={currentPage === 1}
                          style={{
                            border: "1px solid #007bff",
                            margin: "0 1px",
                            padding: "5px 10px",
                            cursor: "pointer",
                            borderRadius: "5px",
                            color: "black",
                          }}
                        >
                          Prev
                        </button>
                        {paginationNumbers.map((num) => (
                          <button
                            key={num}
                            onClick={() => this.handlePageChange(num)}
                            style={{
                              fontWeight:
                                num === currentPage ? "bold" : "normal",
                              backgroundColor:
                                num === currentPage ? "#007bff" : "#fff",
                              color: num === currentPage ? "#fff" : "#000",
                              border: "1px solid #007bff",
                              margin: "0 1px",
                              padding: "5px 10px",
                              cursor: "pointer",
                              borderRadius: "5px",
                            }}
                          >
                            {num}
                          </button>
                        ))}
                        <button
                          onClick={this.handleNextPage}
                          disabled={currentPage === totalPages}
                          style={{
                            color: "black",
                            border: "1px solid #007bff",
                            margin: "0 1px",
                            padding: "5px 10px",
                            cursor: "pointer",
                            borderRadius: "5px",
                          }}
                        >
                          Next
                        </button>
                      </div>

                      {/* Load more + total — loaded / total on the server.
                          "Load more" pulls the next batch from the server and
                          appends it (works alongside search). */}
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12, marginTop: 12 }}>
                        <span style={{ color: "#8ecfda", fontSize: 12, fontWeight: 600 }}>
                          Loaded {(this.state.patients || []).length} of {this.state.totalPatients || (this.state.patients || []).length}
                          {this.state.searchQuery ? " (search)" : ""}
                        </span>
                        {this.state.hasMorePatients && (
                          <button
                            onClick={this.loadMorePatients}
                            disabled={this.state.loadingMore}
                            style={{ padding: "6px 18px", fontSize: 12, fontWeight: 700, background: this.state.loadingMore ? "#0c3a42" : "#0f4a52", border: "2px solid #2eaabb", borderRadius: 6, color: "#ffffff", cursor: this.state.loadingMore ? "wait" : "pointer" }}
                          >
                            {this.state.loadingMore ? "Loading…" : "↓ Load more"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <EcgStripsModal
          userid={this.state.stripsUserid}
          onClose={() => this.setState({ stripsUserid: null })}
        />
      </div>
    );
  }
}

export default VerifierHome;
